<!-- <app-langding-page-nav-bar></app-langding-page-nav-bar> -->

<div class="msg-app-content  post-page-background">
  <div class="container-fluid">
    <div class="" style="margin-top: 67px;">
      <!-- <div class="mainheader" style="display: flex; align-items: center; justify-content: space-between;">
          <div style="display: flex; align-items: center; gap: 10px;">
            <b style="color: black;">Messages</b>
            <div style="position: relative; width: 250px;">
              <ng-icon name="tablerSearch" class="search-icon" style="position: absolute; left: 10px; top: 50%; transform: translateY(-50%); color: #888;"></ng-icon>
              <input type="text" class="form-control search-boxtop" placeholder="Search messages" [(ngModel)]="searchText"
                style="padding-left: 35px;">
            </div>
          </div>
          <div style="display: flex; align-items: center; gap: 10px;">
            <div class="buttonheader">
              <button type="button" class="btn btn-primary btn-sm" (click)="openNewContactModal(newContactModal)">
                Private Chat
              </button>
              <button type="button" class="btn btn-primary btn-sm" (click)="openGroupContactModal(groupModal)">
                Group Chat
              </button>
              <ng-icon name="tablerDots" style="padding-right:10px;"></ng-icon>
            </div>
          </div>
        </div>
            <hr class="custom-hr">
            <div class="menu">
              <nav>
                <ul>
                  <li *ngFor="let item of menuItems"
                      (click)="eventSelection(item.value)"
                      [class.active]="selectedMenu === item.value">
                    {{ item.label }}
                  </li>
                </ul>
              </nav>
            </div> -->
      <!-- Slim sub-header (wireframe gigsumo_unified(48)): page title + Close. -->
      <div class="msg-subheader-650">
        <span class="msg-subheader-title-650">Messages</span>
        <button type="button" class="msg-subheader-close-650" (click)="closeMessages()">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          Close
        </button>
      </div>
      <div class="message-navbar-650">
        <!-- Header "Search messages" bar removed per wireframe gigsumo_unified(48) — no search in the messaging header.
             Tabs are left-aligned; flex space-between keeps the action buttons on the right. -->
        <div class="menu-container-650" [ngClass]="{'compressed-650': isSearchFocused}">
          <ul class="menu-list-650">
            <li *ngFor="let item of menuItems" (click)="eventSelection(item.value)"
              [class.active-menu-650]="selectedMenu === item.value" class="menu-item-650">
              {{ item.label }}
            </li>
          </ul>
          <!-- <div>{{selectedMenu}}--------this.selectedMenu</div> -->
        </div>

        <div class="action-container-650">
          <button type="button" class="msg-hdr-btn msg-hdr-btn--private" (click)="openNewContactModal(newContactModal)">
            <svg xmlns="http://www.w3.org/2000/svg" class="msg-hdr-btn-icon" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
            Private Chat
          </button>
          <button type="button" class="msg-hdr-btn msg-hdr-btn--group" (click)="openGroupContactModal(groupModal)">
            <ng-icon name="tablerUsersGroup" class="msg-hdr-btn-icon"></ng-icon>
            Group Chat
          </button>
          <!-- <div class="more-options-650">
            <ng-icon name="tablerDots"></ng-icon>
          </div> -->
        </div>
      </div>

      <div class="row msg-cols-row">
        <div class="col-md-3 p-r ">
          <div class="hpanel radius-cancel">
            <div class="no-padding border-radius-top-left-right-6 msg-list-panel-650">
              <!-- Search Box — kept OUTSIDE the scroll container so the list scrollbar
                   starts below it (the search row never scrolls). -->
              <div class="search-container-650-1">
                <ng-icon name="tablerSearch" class="search-icon-650-1"></ng-icon>
                <input type="text" class="search-box-650" placeholder="Search by name..." [(ngModel)]="searchTextname"
                  (input)="applySearch()">
                <button *ngIf="searchTextname" type="button" class="search-clear-650" aria-label="Clear search"
                  (click)="clearChatsByTabSearch()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                </button>
              </div>
              <!-- Contact List Component with Enhanced UI -->
              <div class="contact-list-container-650" infiniteScroll [infiniteScrollDistance]="5" [scrollWindow]="false"
                [infiniteScrollThrottle]="150" (scrolled)="UesrsScrollDown()" id="entity-container">
                <!-- chatsByTabSearching: a "Search by name..." request (or the reload that
                     follows clearing it) is in flight — show the loader and suppress the
                     empty-state block below so "No contacts to display" can't flash. -->
                <div class="contacts-list-650" *ngIf="isLoading1 || chatsByTabSearching">
                  <app-common-skeleton  [countforView]="3"
                  [NameOftheScreen]="'userChat'"></app-common-skeleton>
                </div>
                <!-- Contacts List -->
                <div class="contacts-list-650" *ngIf="!isLoading1 && !chatsByTabSearching">

                  <!-- Temporary Contacts -->
                  <ng-container *ngFor="let item of tempContactList | messageContact: contactfil">
                    <div class="contact-item-650"
                      [ngClass]="{'active-650': (SelectedContact['groupId'] === item['groupId'])}">
                      <div class="avatar-container-650">
                        <div [ngSwitch]="item.groupType" class="avatar-650">
                          <!-- Group Avatar -->
                          <img *ngSwitchCase="'GROUP'" class="avatar-img-650"
                            [src]="item['groupLogo'] ? imgUrl+item['groupLogo'] : 'assets/icon/groupimg.png'"
                            [alt]="item['groupName']" onerror="this.src='assets/icon/groupimg.png'">

                          <!-- User Avatar -->
                          <img *ngSwitchCase="'USER'" class="avatar-img-650"
                            [src]="item['groupLogo'] ? imgUrl+item['groupLogo'] : 'assets/images/userAvatar.png'"
                            [alt]="item['groupName']" onerror="this.src='assets/images/userAvatar.png'">

                          <!-- Other Avatar Types -->
                          <img *ngSwitchCase="'JOB'" class="avatar-img-650"
                            [src]="item['groupLogo'] ? imgUrl+item['groupLogo'] : 'assets/images/userAvatar.png'"
                            [alt]="item['groupName']" onerror="this.src='assets/images/userAvatar.png'">

                          <img *ngSwitchCase="'CANDIDATE'" class="avatar-img-650"
                            [src]="item['groupLogo'] ? imgUrl+item['groupLogo'] : 'assets/images/userAvatar.png'"
                            [alt]="item['groupName']" onerror="this.src='assets/images/userAvatar.png'">

                          <img *ngSwitchCase="'NETWORK'" class="avatar-img-650"
                            [src]="item['groupLogo'] ? imgUrl+item['groupLogo'] : 'assets/icon/icons8-share-400.png'"
                            [alt]="item['groupName']" onerror="this.src='assets/icon/icons8-share-400.png'">

                          <img *ngSwitchCase="'TEAM'" class="avatar-img-650"
                            [src]="item['groupLogo'] ? imgUrl+item['groupLogo'] : 'assets/icon/icons8-people-100.png'"
                            [alt]="item['groupName']" onerror="this.src='assets/icon/icons8-people-100.png'">

                          <img *ngSwitchCase="'BUSINESS'" class="avatar-img-650"
                            [src]="item['groupLogo'] ? imgUrl+item['groupLogo'] : 'assets/images/gallery/company.png'"
                            [alt]="item['groupName']" onerror="this.src='assets/images/gallery/company.png'">

                          <img *ngSwitchCase="'COMMUNITY'" class="avatar-img-650"
                            [src]="item['groupLogo'] ? imgUrl+item['groupLogo'] : 'assets/icon/icons8-myspace-400.png'"
                            [alt]="item['groupName']" onerror="this.src='assets/icon/icons8-myspace-400.png'">

                          <img *ngSwitchCase="'SUPPORT'" class="avatar-img-650"
                            [src]="item['groupLogo'] ? imgUrl+item['groupLogo'] : 'assets/icon/Sumoface_final.png'"
                            [alt]="item['groupName']" onerror="this.src='assets/icon/Sumoface_final.png'">

                          <!-- Default for unknown types -->
                          <div *ngSwitchDefault class="avatar-initials-650"
                            [style.background-color]="getColorfullname(item['groupName'])">
                            <div [style.color]="getFullnameTextColor(item['groupName'])"> {{
                              getInitialsfullname(item['groupName']) }}</div>
                          </div>
                        </div>
                      </div>

                      <div class="contact-details-650">
                        <div class="contact-name-650" title="{{item['groupName']}}">{{item['groupName']}}</div>
                      </div>
                    </div>
                  </ng-container>

                  <!-- Main Contact List -->
                  <ng-container *ngFor="let item of contactList | messageContact: contactfil">
                    <div class="contact-item-650"
                      [ngClass]="{'active-650': SelectedContact['groupId'] === item['groupId'] }"
                      (click)="redirectUrl(item)">

                      <div class="avatar-container-650">
                        <div [ngSwitch]="item.groupType" class="avatar-650">
                          <!-- Group Avatar -->
                          <img *ngSwitchCase="'GROUP'" class="avatar-img-650"
                            [src]="item.groupLogo ? imgUrl + item.groupLogo : 'assets/icon/groupimg.png'"
                            [alt]="item.groupName" onerror="this.src='assets/icon/groupimg.png'">

                          <!-- User Avatar -->
                          <ng-container *ngSwitchCase="'USER'">
                            <img *ngIf="item.groupLogo" class="avatar-img-650" [src]="imgUrl + item.groupLogo"
                              [alt]="item.groupName">
                            <div *ngIf="!item.groupLogo" class="avatar-initials-650"
                              [style.background-color]="getColorfullname(item.groupName)">
                              <!-- {{ getInitialsfullname(item.groupName) }} -->
                              <div [style.color]="getFullnameTextColor(item.groupName)"> {{
                                getInitialsfullname(item.groupName) }}</div>
                            </div>
                          </ng-container>

                          <!-- Job Avatar -->
                          <ng-container *ngSwitchCase="'JOB'">
                            <img *ngIf="item.groupLogo" class="avatar-img-650" [src]="imgUrl + item.groupLogo"
                              [alt]="item.groupName">
                            <div *ngIf="!item.groupLogo" class="avatar-initials-650"
                              [style.background-color]="getColorfullname(item.groupName)">
                              <!-- {{ getInitialsfullname(item.groupName) }} -->
                              <div [style.color]="getFullnameTextColor(item.groupName)"> {{
                                getInitialsfullname(item.groupName) }}</div>

                            </div>
                          </ng-container>

                          <!-- Candidate Avatar -->
                          <ng-container *ngSwitchCase="'CANDIDATE'">
                            <img *ngIf="item.groupLogo" class="avatar-img-650" [src]="imgUrl + item.groupLogo"
                              [alt]="item.groupName">
                            <div *ngIf="!item.groupLogo" class="avatar-initials-650"
                              [style.background-color]="getColorfullname(item.groupName)">
                              <div [style.color]="getFullnameTextColor(item.groupName)"> {{
                                getInitialsfullname(item.groupName) }}</div>
                              <!-- {{ getInitialsfullname(item.groupName) }} -->
                            </div>
                          </ng-container>

                          <!-- Other Group Types -->
                          <img *ngSwitchCase="'NETWORK'" class="avatar-img-650"
                            [src]="item.groupLogo ? imgUrl + item.groupLogo : 'assets/icon/icons8-share-400.png'"
                            [alt]="item.groupName" onerror="this.src='assets/icon/icons8-share-400.png'">

                          <img *ngSwitchCase="'TEAM'" class="avatar-img-650"
                            [src]="item.groupLogo ? imgUrl + item.groupLogo : 'assets/icon/icons8-people-100.png'"
                            [alt]="item.groupName" onerror="this.src='assets/icon/icons8-people-100.png'">

                          <img *ngSwitchCase="'BUSINESS'" class="avatar-img-650"
                            [src]="item.groupLogo ? imgUrl + item.groupLogo : 'assets/images/gallery/company.png'"
                            [alt]="item.groupName" onerror="this.src='assets/images/gallery/company.png'">

                          <img *ngSwitchCase="'COMMUNITY'" class="avatar-img-650"
                            [src]="item.groupLogo ? imgUrl + item.groupLogo : 'assets/icon/icons8-myspace-400.png'"
                            [alt]="item.groupName" onerror="this.src='assets/icon/icons8-myspace-400.png'">

                          <img *ngSwitchCase="'SUPPORT'" class="avatar-img-650"
                            [src]="item.groupLogo ? imgUrl + item.groupLogo : 'assets/icon/Sumoface_final.png'"
                            [alt]="item.groupName" onerror="this.src='assets/icon/Sumoface_final.png'">
                        </div>

                        <!-- Status Indicator -->
                        <div *ngIf="item.groupType=='JOB'||item.groupType=='CANDIDATE'||item.groupType=='USER'"
                          class="status-indicator-650" [ngClass]="isOnline(item['online']) ? 'online-650' : 'offline-650'">
                        </div>
                      </div>

                      <!-- Contact Details -->
                      <div class="contact-details-650">
                        <!-- Name with Group Type Prefix -->
                        <div class="contact-name-650" title="{{item['groupName']}}">
                          <span *ngIf="item.groupType=='NETWORK'" class="group-type-prefix-650">(N)</span>
                          <span *ngIf="item.groupType=='TEAM'" class="group-type-prefix-650">(W)</span>
                          <span *ngIf="item.groupType=='BUSINESS'" class="group-type-prefix-650">(B)</span>
                          <span *ngIf="item.groupType=='COMMUNITY'" class="group-type-prefix-650">(C)</span>
                          {{item['groupName']}}
                        </div>

                        <!-- Entity ID for Job/Candidate -->
                        <div *ngIf="item.groupType=='CANDIDATE' || item.groupType=='JOB'" class="contact-entity-id-650"
                          title="{{item?.entityId}}">
                          ID: {{item['entityId']}}
                        </div>

                        <!-- Group initiated by info -->
                        <div
                          *ngIf="item['groupType']!='USER' && item['groupType']!='CANDIDATE' && item['groupType']!='JOB' && item.title !=null && item.title?.lenght !=0"
                          class="contact-type-650" [title]="'Initiated by ' + (item.title === 'Gigsumo Support' ? 'You' : item.title)">
                          <span>Initiated by </span>
                          <span *ngIf="item.title=='Gigsumo Support'">You</span>
                          <span *ngIf="item.title!='Gigsumo Support'">{{item.title}}</span>
                        </div>

                        <!-- Last message preview (no lastMessage = conversation not started) -->
                        <div class="contact-type-650" [title]="item.lastMessage || 'No messages yet — start a conversation'">
                          <span *ngIf="item.lastMessage">{{item.lastMessage}}</span>
                          <span *ngIf="!item.lastMessage">No messages yet <span class="dash-wide">—</span> start a conversation</span>
                        </div>
                      </div>

                      <!-- Time and Notifications -->
                      <div class="contact-meta-650">
                        <div class="contact-time-650">
                          <span *ngIf="!dateDiff(item['lastMessageOn'])">
                            {{item['lastMessageOn'] | timezoneDate:'MM/dd/yyyy'}}
                          </span>
                          <span *ngIf="dateDiff(item['lastMessageOn'])">
                            {{item['lastMessageOn'] | timezoneDate:'h:mm a'}}
                          </span>
                        </div>

                        <div *ngIf="item['nonSeenCount'] && item['nonSeenCount'] > 0" class="notification-badge-650">
                          {{item['nonSeenCount']}}
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <!-- Remaining Contacts -->
                  <ng-container *ngFor="let item of remainingContact | messageContact: contactfil">
                    <!-- Similar structure as contactList but for remainingContact -->
                    <div class="contact-item-650"
                      [ngClass]="{'active-650': SelectedContact['groupId'] === item['groupId'] }"
                      (click)="redirectUrl(item)">

                      <div class="avatar-container-650">
                        <div [ngSwitch]="item.groupType" class="avatar-650">
                          <!-- Group Avatar -->
                          <img *ngSwitchCase="'GROUP'" class="avatar-img-650"
                            [src]="item['groupLogo'] ? imgUrl+item['groupLogo'] : 'assets/icon/groupimg.png'"
                            [alt]="item['groupName']" onerror="this.src='assets/icon/groupimg.png'">

                          <!-- User Avatar -->
                          <img *ngSwitchCase="'USER'" class="avatar-img-650"
                            [src]="item['groupLogo'] ? imgUrl+item['groupLogo'] : 'assets/images/userAvatar.png'"
                            [alt]="item['groupName']" onerror="this.src='assets/images/userAvatar.png'">

                          <!-- Other Avatar Types -->
                          <img *ngSwitchCase="'NETWORK'" class="avatar-img-650"
                            [src]="item['groupLogo'] ? imgUrl+item['groupLogo'] : 'assets/icon/icons8-share-400.png'"
                            [alt]="item['groupName']" onerror="this.src='assets/icon/icons8-share-400.png'">

                          <img *ngSwitchCase="'TEAM'" class="avatar-img-650"
                            [src]="item['groupLogo'] ? imgUrl+item['groupLogo'] : 'assets/icon/icons8-people-100.png'"
                            [alt]="item['groupName']" onerror="this.src='assets/icon/icons8-people-100.png'">

                          <img *ngSwitchCase="'BUSINESS'" class="avatar-img-650"
                            [src]="item['groupLogo'] ? imgUrl+item['groupLogo'] :'assets/images/gallery/company.png'"
                            [alt]="item['groupName']" onerror="this.src='assets/images/gallery/company.png'">

                          <img *ngSwitchCase="'COMMUNITY'" class="avatar-img-650"
                            [src]="item['groupLogo'] ? imgUrl+item['groupLogo'] : 'assets/icon/icons8-myspace-400.png'"
                            [alt]="item['groupName']" onerror="this.src='assets/icon/icons8-myspace-400.png'">

                          <img *ngSwitchCase="'SUPPORT'" class="avatar-img-650"
                            [src]="item['groupLogo'] ? imgUrl+item['groupLogo'] : 'assets/icon/Sumoface_final.png'"
                            [alt]="item['groupName']" onerror="this.src='assets/icon/Sumoface_final.png'">
                        </div>

                        <!-- Status Indicator -->
                        <span class="status-dot-650"
                          [style.background-color]="isOnline(item['online']) ? 'var(--gs-green)' : 'var(--gs-gray-500)'"></span>
                      </div>

                      <!-- Contact Details -->
                      <div class="contact-details-650">
                        <!-- Name with Group Type Prefix -->
                        <div class="contact-name-650" title="{{item['groupName']}}">
                          <span *ngIf="item.groupType=='NETWORK'" class="group-type-prefix-650">(N)</span>
                          <span *ngIf="item.groupType=='TEAM'" class="group-type-prefix-650">(W)</span>
                          <span *ngIf="item.groupType=='BUSINESS'" class="group-type-prefix-650">(B)</span>
                          <span *ngIf="item.groupType=='COMMUNITY'" class="group-type-prefix-650">(C)</span>
                          {{item['groupName']}}
                        </div>

                        <!-- Group initiated by info -->
                        <div *ngIf="item['groupType']!='USER' && item.title !=null && item.title?.lenght !=0"
                          class="contact-type-650" title="Initiated by {{item.title}}">
                          <span>Initiated by </span>
                          <span>{{item.title}}</span>
                        </div>

                        <!-- Last message preview (no lastMessage = conversation not started) -->
                        <div class="contact-type-650" [title]="item.lastMessage || 'No messages yet — start a conversation'">
                          <span *ngIf="item.lastMessage">{{item.lastMessage}}</span>
                          <span *ngIf="!item.lastMessage">No messages yet <span class="dash-wide">—</span> start a conversation</span>
                        </div>
                      </div>

                      <!-- Time and Notifications -->
                      <div class="contact-meta-650">
                        <div class="contact-time-650">
                          {{item['lastMessageOn'] | timezoneDate}}
                        </div>

                        <div *ngIf="item['nonSeenCount'] && item['nonSeenCount'] > 0" class="notification-badge-650">
                          {{item['nonSeenCount']}}
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <!-- Loading more (scroll pagination) — bottom skeleton instead of the util spinner -->
                  <app-common-skeleton *ngIf="loadingMore650" [countforView]="3"
                    [NameOftheScreen]="'userChat'"></app-common-skeleton>


                  <!-- No Data State -->
                  <div *ngIf="!isLoading
                              && (tempContactList | messageContact: contactfil)?.length == 0
                              && (contactList | messageContact: contactfil)?.length == 0
                              && (remainingContact | messageContact: contactfil)?.length == 0"
                       class="empty-contacts-650">
                    <ng-icon name="tablerMessages" class="empty-contacts-icon-650"></ng-icon>
                    <p>No contacts to display</p>
                    <p>Try a different search term</p>
                  </div>

                  <!-- Loading Skeleton -->
                  <app-common-skeleton *ngIf="isLoading" [countforView]="3"
                    [NameOftheScreen]="'userChat'"></app-common-skeleton>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="col-md-6 p-l col-pd-0">
          <app-common-skeleton class="col-md-12 padding-left-5 p-r" *ngIf="isLoading" [countforView]="3"
            [NameOftheScreen]="'Chatmidsection'"></app-common-skeleton>

              <!-- Empty State Container - Show when no chat is selected -->
          <div *ngIf="!isLoading && messageStatus === selectMessage.EMPTY" class="col-md-12 p-r padding-left-5 p-r">
            <div class="hpanel">
              <div class="panel-body empty-message-container-1 border-radius-top-left-right-6 text-center">
                <div class="chat-empty-container">
                  <div class="chat-empty-content">
                    <div class="chat-empty-icon">
                      <ng-icon name="tablerMessages"></ng-icon>
                    </div>
                    <div class="chat-empty-title">Select a chat or start a new conversation</div>
                    <div class="chat-empty-subtitle">
                      Stay connected with your contacts through private and group chats
                    </div>
                    <!-- <div class="chat-empty-actions">
                      <button class="btn primary-btn block-btn" (click)="openNewContactModal(newContactModal)">
                        <ng-icon name="tablerUserPlus"></ng-icon> New Private Chat
                      </button>
                      <button class="btn primary-btn block-btn" (click)="openGroupContactModal(groupModal)">
                        <ng-icon name="tablerUsers"></ng-icon> New Group Chat
                      </button>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div *ngIf="contactList?.length >= 0&& !isLoading &&nodatafound" class="col-md-12 p-r padding-left-5  p-r">
              <div class="hpanel">
                <div class="panel-body empty-message-container-1 border-radius-top-left-right-6 text-center">
                  <div class="empty-message">
                    <span class="text">Start a conversation with someone!</span>
                    <span class="chat-box">
                      <ng-icon name="tablerMessages"></ng-icon>
                      <span class="chat-text">chat</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <ng-container *ngIf="contactList?.length >0&& !nodatafound && !isLoading&&!contactdatafound">
              <div [ngSwitch]="messageStatus">
                <div *ngSwitchCase="selectMessage.EMPTY">
                  <div class="col-md-12 p-r padding-left-5  p-r">
                    <div class="hpanel ">
                      <div class="panel-body empty-message-container-1 border-radius-top-left-right-6 text-center">
                        <div class="empty-message">
                          <span class="text">Start a conversation with someone!</span>
                          <span class="chat-box">
                            <ng-icon name="tablerMessages"></ng-icon>
                            <span class="chat-text">chat</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngSwitchCase="selectMessage.MESSAGE">

                  <div class="col-md-12 padding-left-5  p-r">
                    <div class="hpanel m-b-0">
                      <div class="panel-body no-padding border-radius-top-left-right-6">
                        <div class="chat-discussion-header border-radius-top-left-right-6">
                          <ng-container [ngTemplateOutlet]="selecteduser"></ng-container>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 padding-left-5 p-r">
                    <div class="hpanel ">
                      <div class="panel-body no-padding">
                        <div class="chat-discussion-top">
                          <div class="chat-discussion" id="chat-discussion" #chartDiscussion messagescroll
                            infiniteScroll [infiniteScrollDistance]="4" [infiniteScrollUpDistance]="6"
                            [scrollWindow]="false" (scrolledUp)="onScrollUp()">
                            <ng-container *ngIf="messageList?.length==0 && SelectedContact.groupType=='SUPPORT'">
                              <div class="nodata-found-msg">
                                <img src="assets/images/no-chat-found.gif">
                              </div>
                            </ng-container>

                            <ng-container *ngIf="messageList?.length==0 && SelectedContact.groupType!='SUPPORT'">
                              <div class="nodata-found-msg" style="margin-top: 150px;">
                                No conversation yet.
                              </div>
                            </ng-container>
                            <ng-container *ngFor="let item of sortByMsg(messageList, 'sentDate') | messageunique">
                              <div class="chat-message" *ngIf="item.eventType=='CHAT' || item.eventType==null"
                                [id]="item['messageId']"
                                [ngClass]="{'right': item['authorId'] === userId, 'left': item['authorId'] !== userId}">

                                <div class="btn-group three_icon_cmon1 hover" dropdown container="body">

                                  <a id="button-animated" dropdownToggle
                                    *ngIf="item.enableDelete && item.authorId==userId">
                                    <ng-icon name="tablerDots" class="three-dot"></ng-icon>
                                  </a>
                                  <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu msg-opts-menu" role="menu"
                                    style="right: 0; left: auto;margin-top: -23px;" aria-labelledby="button-animated">
                                    <ng-container>
                                      <li role="menuitem">
                                        <a (click)="edit(item)">
                                          <ng-icon name="tablerPencil" class="m-5"></ng-icon> Edit
                                        </a>
                                      </li>
                                      <li role="menuitem">
                                        <a (click)="delete(item)" class="msg-drop-danger">
                                          <ng-icon name="tablerTrash" class="m-5"></ng-icon> Delete
                                        </a>
                                      </li>
                                    </ng-container>
                                  </ul>
                                </div>
                                <img *ngIf="item['authorPhoto']" class="message-avatar"
                                  [src]="imgUrl+item['authorPhoto']">

                                <div class="message-avatar" *ngIf="!item['authorPhoto']">
                                  <div class="circles mr-rt-10"
                                    [style.background-color]="getColorfullname(item['authorName'])">
                                    <div class="circle-text">{{ getInitialsfullname(item['authorName']) }}</div>
                                  </div>
                                </div>

                                <div class="message" [id]="item['message']">
                                  <a class="message-author"> {{item['authorName']}}
                                  </a>


                                  <span class="message-date"> {{item['sentDate'] | timezoneDate:'custom' }} </span>

                                  <span class="message-content" style=" word-wrap: break-word"
                                    [innerHTML]="item['message']"> </span>
                                  <div style="width: 100%;">
                                    <div style="display: flex; flex-wrap: wrap;">
                                      <div *ngFor="let at of item.attachments; let a = index;">

                                        <ng-container>
                                          <ng-container *ngIf="at['attachmentType'] === 'image'">
                                            <img [src]="imgUrl+at['url']" height="92" style="margin: 3px;"
                                              (click)="showImageAndVideoPreview(item, a)">
                                          </ng-container>

                                          <ng-container *ngIf="at['attachmentType'] === 'video'">
                                            <video height="92" style="margin: 3px;"
                                              (click)="showImageAndVideoPreview(item, a)">
                                              <source [src]="imgUrl+at['url']" [type]="at['mimetype']" />
                                              Browser not supported
                                            </video>
                                          </ng-container>
                                          <ng-container *ngIf="at['attachmentType'] === 'application'">
                                            <div class="attach-application">
                                              name
                                            </div>
                                          </ng-container>
                                          <ng-container *ngIf="at['attachmentType'] === 'audio'">
                                          </ng-container>
                                          <ng-container *ngIf="at['attachmentType'] === 'others'">
                                            <div class="attach-others">
                                              name
                                            </div>
                                          </ng-container>
                                        </ng-container>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="chat-message" *ngIf="item.eventType=='ACTION'" [id]="item['messageId']"
                                [ngClass]="{'right': item['authorId'] === userId, 'left': item['authorId'] !== userId}">
                                <span class="message-content"
                                  style="text-align: center; color: #655b4e;font-size: 10px;"
                                  [innerHTML]="item['oldMessage'] "></span>
                              </div>
                            </ng-container>
                          </div>
                          <div>
                            <p class="text-center"
                              *ngIf="SelectedContact?.status == 'INACTIVE' && SelectedContact?.groupType == 'USER'"> You
                              are
                              no longer connected with this user and hence you cannot chat</p>
                            <p class="text-center"
                              *ngIf="SelectedContact?.status == 'INACTIVE' && (SelectedContact?.groupType == 'JOB' || SelectedContact?.groupType == 'CANDIDATE')">
                              You are no longer connected with this user and hence you cannot chat</p>
                          </div>

                          <div class="panel-footer msg-panel-footer borders"
                            *ngIf="messageStatus === selectMessage.MESSAGE">
                            <ng-container *ngIf="!attachment && !imageAttachmentEdit">
                              <form style="display: flex; width: 100%;" *ngIf="SelectedContact.status!='INACTIVE'"
                                #myForm="ngForm">
                                <div class="message-attachment">
                                  <ng-icon name="tablerPaperclip"></ng-icon>
                                  <input type="file" multiple id="attachmentfile" name="file"
                                    accept="image/*,audio/*,video/*"
                                    (click)="UploadFileInput.value=''"
                                    (change)="fileUpload($event,'', 'fileupload')" #UploadFileInput />

                                </div>

                                <div class="send-msg-txt">

                                  <div [(ngModel)]="sendMessageData['message']" name="message" [ngxSummernote]="config"
                                    summernoteValidator #message="ngModel" required>
                                  </div>



                                </div>
                                <div class="send-msg-btn" style="margin-top: 7px;"
                                  *ngIf="!editMessage && !imageAttachmentEdit">
                                  <button type="submit" id="sendmsg"
                                    [disabled]="editorDisabled || message.errors?.summernoteEmpty"
                                    class="btn btn-primary btn-sm" (click)="sendMessage()">
                                    Send
                                  </button>
                                </div>

                                <div class="send-msg-btn" style="margin-top: 7px;" *ngIf="editMessage">
                                  <button type="submit" id="sendmsg"
                                    [disabled]="editorDisabled || message.errors?.summernoteEmpty"
                                    class="btn btn-primary btn-sm" (click)="updateMsg()">
                                    Update
                                  </button>
                                </div>
                              </form>
                            </ng-container>
                            <div *ngIf="attachment && imageAttachmentEdit==false" style="width: 100%;">
                              <div style="display: flex; flex-wrap: wrap;">
                                <div style="position: relative; float: left;"
                                  *ngFor="let item of uploadFiles; let i = index;">
                                  <ng-container *ngIf="item['t'] === 'image'">
                                    <img [src]="item['src']"
                                      style="margin-bottom: 10px; height: 93px;margin-right: 10px;">
                                    <ng-icon name="tablerTrash" class="attach-remove" (click)="removeAttachMent(item, i)"></ng-icon>
                                  </ng-container>
                                  <ng-container *ngIf="item['t'] === 'video'">
                                    <video style="margin-bottom: 10px; height: 93px;margin-right: 10px;" controls
                                      (click)="toggleVideo()" #videoPlayer>
                                      <source [src]="item['src']" [type]="item['ft']" />
                                      Browser not supported
                                    </video>
                                    <ng-icon name="tablerTrash" class="attach-remove" (click)="removeAttachMent(item, i)"></ng-icon>
                                  </ng-container>
                                  <ng-container *ngIf="item['t'] === 'application'">
                                    <div class="attach-application">
                                      <ng-icon name="tablerTrash" class="attach-remove"></ng-icon>

                                    </div>
                                  </ng-container>
                                  <ng-container *ngIf="item['t'] === 'audio'">
                                    <div class="attach-application">
                                      <ng-icon name="tablerTrash" class="attach-remove"></ng-icon>
                                      <audio controls>
                                        <source [src]="item['src']" [type]="item['ft']">
                                        Your browser does not support the audio tag.
                                      </audio>
                                    </div>
                                  </ng-container>
                                  <ng-container *ngIf="item['t'] === 'others'">
                                    <div class="attach-others">
                                      <ng-icon name="tablerTrash" class="attach-remove"></ng-icon>

                                    </div>
                                  </ng-container>
                                </div>
                                <div class="col-md-3 upload-file">
                                  <button type="button" name="" id="" class="btn">
                                    <ng-icon name="tablerPlus"></ng-icon>
                                    <input type="file" multiple accept="image/*,audio/*,video/*"
                                      id="attachmentfile" name="file"
                                      (click)="UploadFileInput.value=''"
                                      (change)="fileUpload($event, UploadFileInput, 'update')" #UploadFileInput />
                                  </button>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-md-12" style="display: flex; flex-wrap: wrap;">
                                  <form style="display: flex; width: 100%;" (submit)="sendMessageWithAttachment()"
                                    *ngIf="SelectedContact.status !== 'INACTIVE'" #myForm="ngForm">
                                    <div class="send-msg-txt" style="flex-grow: 1;">
                                      <div [(ngModel)]="sendMessageData['message']" name="message"
                                        [ngxSummernote]="config" summernoteValidator #message="ngModel" id="summessage"
                                        required>
                                      </div>
                                    </div>
                                    <div class="send-msg-btn" style="margin-top: 7px;">
                                      <button class="btn btn-primary btn-sm" type="submit" id="sendmsg">
                                        Send
                                      </button>
                                    </div>
                                  </form>
                                </div>
                              </div>

                            </div>

                            <div *ngIf="imageAttachmentEdit" style="width: 100%;">
                              <div style="display: flex; flex-wrap: wrap;">
                                <div style="position: relative; float: left;"
                                  *ngFor="let item of uploadFiles; let i = index;">
                                  <ng-container *ngIf="item['t'] === 'image'">
                                    <img [src]="item['src']" *ngIf="item?.edit==undefined"
                                      style="margin-bottom: 10px; height: 93px;margin-right: 10px;">
                                    <img [src]="imgUrl+item.url" *ngIf="item?.edit==true"
                                      style="margin-bottom: 10px; height: 93px;margin-right: 10px;">
                                    <ng-icon name="tablerTrash" class="attach-remove" (click)="removeAttachMentedit(item, i)"></ng-icon>
                                  </ng-container>
                                  <ng-container *ngIf="item['t'] === 'video'">
                                    <video *ngIf="item?.edit==undefined"
                                      style="margin-bottom: 10px; height: 93px;margin-right: 10px;" controls
                                      (click)="toggleVideo()" #videoPlayer>
                                      <source [src]="item['src']" [type]="item['ft']" />
                                      Browser not supported
                                    </video>

                                    <video *ngIf="item?.edit==true"
                                      style="margin-bottom: 10px; height: 93px;margin-right: 10px;" controls
                                      (click)="toggleVideo()" #videoPlayer>
                                      <source [src]="imgUrl+item.url" [type]="item['ft']" />
                                      Browser not supported
                                    </video>

                                    <ng-icon name="tablerTrash" class="attach-remove" (click)="removeAttachMentedit(item, i)"></ng-icon>
                                  </ng-container>
                                  <ng-container *ngIf="item['t'] === 'application'">
                                    <div class="attach-application">
                                      <ng-icon name="tablerTrash" class="attach-remove"></ng-icon>

                                    </div>
                                  </ng-container>
                                  <ng-container *ngIf="item['t'] === 'audio'">
                                    <div class="attach-application">
                                      <ng-icon name="tablerTrash" class="attach-remove"></ng-icon>
                                      <audio controls>
                                        <source [src]="item['src']" [type]="item['ft']">
                                        Your browser does not support the audio tag.
                                      </audio>
                                    </div>
                                  </ng-container>
                                  <ng-container *ngIf="item['t'] === 'others'">
                                    <div class="attach-others">
                                      <ng-icon name="tablerTrash" class="attach-remove"></ng-icon>

                                    </div>
                                  </ng-container>
                                </div>
                                <div class="col-md-3 upload-file">
                                  <button type="button" name="" id="" class="btn">
                                    <ng-icon name="tablerPlus"></ng-icon>
                                    <input type="file" multiple accept="image/*,audio/*,video/*"
                                      id="attachmentfile" name="file"
                                      (click)="UploadFileInput.value=''"
                                      (change)="fileUpload($event, UploadFileInput, 'update')" #UploadFileInput />
                                  </button>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-12" style="display: flex; flex-wrap: wrap;">
                                  <form style="display: flex; width: 100%;" *ngIf="SelectedContact.status!='INACTIVE'">
                                    <div class="send-msg-txt">
                                      <div [(ngModel)]="sendMessageData['message']" summernoteValidator
                                        #messagesss="ngModel" name="messagesss" id="summessage"
                                        [ngxSummernote]="config"></div>
                                    </div>
                                    <div class="send-msg-btn">
                                      <button class="btn btn-primary btn-sm " type="submit" id="sendmsg"
                                        *ngIf="uploadFiles.length>0" (click)="updatemediaApi()"
                                        [disabled]="uploadFiles.length <= 0">
                                        Update
                                      </button>

                                      <button class="btn btn-primary btn-sm " type="submit" id="sendmsg"
                                        *ngIf="uploadFiles.length==0" (click)="updatemediaApi()"
                                        [disabled]="messagesss?.errors?.summernoteEmpty ">
                                        Update
                                      </button>
                                    </div>

                                  </form>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container> -->

          <!-- Chat Message Container Component with Enhanced UI -->
          <div class="chat-container-107 radius-cancel" *ngIf="SelectedContact?.groupType!= '' && !isLoading && messageStatus === selectMessage.MESSAGE">
            <!-- Chat Header -->
            <div class="chat-header-107">
              <div class="chat-header-left-107">
                <div class="chat-header-avatar-107">
                  <ng-container *ngIf="SelectedContact?.groupType==='USER'">
                    <img *ngIf="SelectedContact?.groupLogo" [src]="imgUrl + SelectedContact.groupLogo"
                      [alt]="SelectedContact.groupName">

                    <div *ngIf="!SelectedContact?.groupLogo" class="circles-107"
                      [style.background-color]="getColorfullname(SelectedContact['groupName'])">
                      <div class="circle-text-107">{{ getInitialsfullname(SelectedContact['groupName']) }}</div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="SelectedContact?.groupType==='JOB' 
                          || SelectedContact?.groupType==='CANDIDATE'">
                    <img *ngIf="SelectedContact?.groupLogo" [src]="imgUrl + SelectedContact.groupLogo"
                      [alt]="SelectedContact.title">

                    <div *ngIf="!SelectedContact?.groupLogo" class="circles-107"
                      [style.background-color]="getColorfullname(SelectedContact['title'])">
                      <div class="circle-text-107">{{ getInitialsfullname(SelectedContact['title']) }}</div>
                    </div>
                  </ng-container>

                  <img *ngIf="SelectedContact?.groupType==='GROUP'"
                    [src]="SelectedContact.groupLogo ? imgUrl + SelectedContact.groupLogo : 'assets/icon/groupimg.png'"
                    [alt]="SelectedContact.groupName" onerror="this.src='assets/icon/groupimg.png'">
                  <img *ngIf="SelectedContact?.groupType==='TEAM'"
                    [src]="SelectedContact.groupLogo ? imgUrl + SelectedContact.groupLogo : 'assets/icon/icons8-people-100.png'"
                    [alt]="SelectedContact.groupName" onerror="this.src='assets/icon/icons8-people-100.png'">
                  <img *ngIf="SelectedContact?.groupType==='SUPPORT'"
                    [src]="SelectedContact.groupLogo ? imgUrl + SelectedContact.groupLogo : 'assets/icon/Sumoface_final.png'"
                    [alt]="SelectedContact.groupName" onerror="this.src='assets/icon/Sumoface_final.png'">
                  <img *ngIf="SelectedContact?.groupType==='BUSINESS'"
                    [src]="SelectedContact.groupLogo ? imgUrl + SelectedContact.groupLogo : 'assets/images/gallery/company.png'"
                    [alt]="SelectedContact.groupName" onerror="this.src='assets/images/gallery/company.png'">
                  <img *ngIf="SelectedContact?.groupType==='COMMUNITY'"
                    [src]="SelectedContact.groupLogo ? imgUrl + SelectedContact.groupLogo : 'assets/icon/community.png'"
                    [alt]="SelectedContact.groupName" onerror="this.src='assets/icon/community.png'">

                </div>
                <div class="chat-header-user-info-107">
                  <div *ngIf="SelectedContact?.groupType==='SUPPORT'" class="chat-header-username-107">Gigsumo Support</div>
                  <div class="chat-header-username-107" style="cursor: pointer;"
                    title="{{SelectedContact.groupName}}"
                    (click)="routeProfie(SelectedContact)">{{SelectedContact.groupName}}</div>
                  <div class="chat-header-status-107 cursor"
                    *ngIf="SelectedContact.groupType=='GROUP' && SelectedContact.nonSeenCount!=0 &&  SelectedContact.status=='ACTIVE'"
                    (click)="userData(SelectedContact,userProfiledata,businessGrouplist,communityMemberview)">
                    Group Member<span *ngIf="SelectedContact.nonSeenCount>1">s</span> :{{SelectedContact.nonSeenCount}}
                  </div>

                  <div class="chat-header-status-107 cursor" *ngIf="SelectedContact.groupType=='TEAM' && SelectedContact.nonSeenCount!=0 &&
                              SelectedContact.status=='ACTIVE' && SelectedContact.members.length!=0"
                    (click)="userData(SelectedContact,userProfileNetworkTeam,businessGrouplist,communityMemberview)">
                    Member<span *ngIf="SelectedContact.members.length>1">s</span> :
                    <ng-container>
                      <span *ngFor="let item of SelectedContact.members; let i=index;">
                        <span *ngIf="i<1"> {{item.firstName}} </span>
                        <span *ngIf="i==1 && SelectedContact.members.length==1"
                          (click)="listofUsers(userProfileNetworkTeam)">,
                          1
                          more.. </span>
                        <span *ngIf="i==1 && SelectedContact.members.length>1"
                          (click)="listofUsers(userProfileNetworkTeam)">,
                          {{SelectedContact.members.length-1}} more.. </span>
                      </span>
                    </ng-container>
                  </div>


                  <div class="chat-header-status-107 cursor" *ngIf="SelectedContact?.groupType=='NETWORK' && SelectedContact?.nonSeenCount!=0 &&
                              SelectedContact?.status=='ACTIVE' && SelectedContact?.members?.length!=0"
                    (click)="userData(SelectedContact,userProfileNetworkTeam,businessGrouplist,communityMemberview)">
                    Member<span *ngIf="SelectedContact?.members?.length>1">s</span> :
                    <ng-container>
                      <span *ngFor="let item of SelectedContact?.members; let i=index;">
                        <span *ngIf="i<1"> {{item.firstName}} </span>
                        <span *ngIf="i==1 && SelectedContact?.members?.length==1"
                          (click)="listofUsers(userProfileNetworkTeam)">, 1
                          more.. </span>
                        <span *ngIf="i==1 && SelectedContact?.members?.length>1"
                          (click)="listofUsers(userProfileNetworkTeam)">,
                          {{SelectedContact.members.length-1}} more.. </span>
                      </span>

                    </ng-container>
                  </div>
                  <div class="chat-header-status-107"
                    *ngIf="SelectedContact.groupType=='USER' || SelectedContact.groupType=='JOB' || SelectedContact.groupType=='CANDIDATE'">
                    <span class="status-dot-107"
                      [ngClass]="isOnline(SelectedContact.online) ? 'online-107' : 'offline-107'"></span>
                    <span>{{isOnline(SelectedContact.online) ? 'Online' : 'Offline'}}</span>
                  </div>
                </div>
              </div>
              <div class="chat-header-right-107">
                <div class="edit-user-107"
                  *ngIf="SelectedContact.isAutoGeneratedGroupName!=true && SelectedContact.groupType=='COMMUNITY'"
                  (click)="userData(SelectedContact,userProfiledata,communityMemberview,userProfileNetworkTeam)"
                  title="Edit {{SelectedContact['groupName']}}">
                  <ng-icon name="tablerPencil" class="position-eye-107"></ng-icon>
                </div>

                <div class="edit-user-107" *ngIf=" SelectedContact.groupType =='TEAM'"
                  (click)="userData(SelectedContact,userProfileNetworkTeam,businessGrouplist,userProfileNetworkTeam)"
                  title="Edit {{SelectedContact['groupName']}}">
                  <ng-icon name="tablerPencil" class="position-eye-107"></ng-icon>
                </div>

                <div class="edit-user-107" *ngIf=" SelectedContact.groupType =='NETWORK'"
                  (click)="userData(SelectedContact,userProfileNetworkTeam,businessGrouplist,userProfileNetworkTeam)"
                  title="Edit {{SelectedContact['groupName']}}">
                  <ng-icon name="tablerPencil" class="position-eye-107"></ng-icon>
                </div>

                <div class="edit-user-107" *ngIf=" SelectedContact.groupType =='GROUP'"
                  (click)="userData(SelectedContact,userProfiledata,businessGrouplist,userProfileNetworkTeam)"
                  title="Edit {{SelectedContact['groupName']}}">
                  <ng-icon name="tablerPencil" class="position-eye-107"></ng-icon>
                </div>

                <div class="edit-user-107"
                  *ngIf=" SelectedContact.groupType =='BUSINESS' && SelectedContact.userId==userId"
                  (click)="userData(SelectedContact,userProfiledata,businessGrouplist,userProfileNetworkTeam)"
                  title="Edit {{SelectedContact['groupName']}}">
                  <ng-icon name="tablerPencil" class="position-eye-107"></ng-icon>
                </div>

                <div *ngIf="SelectedContact.createdBy==userId && SelectedContact.groupType !='BUSINESS'
                    && SelectedContact.groupType !='JOB' && SelectedContact.groupType !='CANDIDATE'"
                  title="Add members" class="add-user-107" (click)="addcontact(groupAdduserModal,groupAdduserModal)">
                  <ng-icon name="tablerUserPlus"></ng-icon>
                </div>
                <!-- Search in conversation: icon that expands into a search bar -->
                <div class="chat-header-act" *ngIf="!showConvoSearch" (click)="openConvoSearch()"
                  title="Search in conversation">
                  <ng-icon name="tablerSearch"></ng-icon>
                </div>
                <div class="chat-search-107" *ngIf="showConvoSearch">
                  <ng-icon name="tablerSearch" class="chat-search-icon-107"></ng-icon>
                  <input type="text" class="form-control" placeholder="Search in conversation..."
                    [(ngModel)]="convoSearchKeyword" (input)="onConvoSearchInput()"
                    (blur)="closeConvoSearch()">

                  <!-- Explicit close — (mousedown) preventDefault stops the input's (blur)
                       above from firing first and racing this button's own click. -->
                  <button type="button" class="chat-search-close-107" aria-label="Close search"
                    (mousedown)="$event.preventDefault()" (click)="closeConvoSearch()">
                    <ng-icon name="tablerX"></ng-icon>
                  </button>

                  <!-- (mousedown) preventDefault stops the input's (blur) above from
                       firing (and collapsing this list) before a result's own click. -->
                  <ul class="convo-search-results" *ngIf="convoSearchKeyword && convoSearchResults.length > 0"
                    (mousedown)="$event.preventDefault()" infiniteScroll [infiniteScrollDistance]="2"
                    [scrollWindow]="false" (scrolled)="onConvoSearchScroll()">
                    <li *ngFor="let item of convoSearchResults"
                      (click)="getSearchMessageDetails(item)">
                      <span class="convo-search-result-date">{{ item['sentDate'] | timezoneDate }}</span>
                      <span class="convo-search-result-text">{{ item['message'] ? stripHtmlTags(item['message']) : '' }}</span>
                    </li>
                    <li *ngIf="convoSearchLoadingMore" class="convo-search-result-loading">Loading…</li>
                  </ul>
                  <div class="convo-search-no-results"
                    *ngIf="convoSearchKeyword && !convoSearchLoading && convoSearchResults.length === 0">
                    No messages found
                  </div>
                </div>

                <!-- Video / Voice call — visual parity with the wireframe, disabled for now -->
                <div class="chat-header-act is-disabled" title="Video call">
                  <ng-icon name="tablerVideo"></ng-icon>
                </div>
                <div class="chat-header-act is-disabled" title="Voice call">
                  <ng-icon name="tablerPhone"></ng-icon>
                </div>

                <!-- Three-dot menu — wireframe parity, disabled for now (same as call/video) -->
                <div class="chat-header-act is-disabled" title="More options">
                  <ng-icon name="tablerDots"></ng-icon>
                </div>

                <div class="chat-close-button-107" (click)="closeChat()">
                    <ng-icon name="tablerX" class="close-svg"></ng-icon>
                  </div>
              </div>
            </div>

            <!-- Rest of the chat container content remains unchanged -->
            <!-- Rest of the chat container content remains unchanged -->
            <!-- Chat Messages -->
            <div class="chat-messages-container-107" #chartDiscussion messagescroll infiniteScroll
              [infiniteScrollDistance]="4" [infiniteScrollUpDistance]="6" [scrollWindow]="false"
              (scroll)="closeMessageDropdowns()" (scrolledUp)="onScrollUp()">

              <!-- Skeleton while a chat's messages are loading — mirrors the real
                   -107 message rows (alternating sender/receiver) so nothing jumps
                   when the messages arrive. Prevents the "No messages yet" flash. -->
              <div class="msg-skeleton-107" *ngIf="messageList?.length === 0 && isMessagesLoading">
                <div class="message-wrapper-107 message-sender-107">
                  <div class="message-avatar-107"><div class="msg-skel msg-skel-avatar"></div></div>
                  <div class="message-content-wrapper-107">
                    <div class="msg-skel msg-skel-name"></div>
                    <div class="msg-skel msg-skel-bubble" style="width: 150px;"></div>
                  </div>
                </div>
                <div class="message-wrapper-107 message-receiver-107">
                  <div class="message-avatar-107"><div class="msg-skel msg-skel-avatar"></div></div>
                  <div class="message-content-wrapper-107">
                    <div class="msg-skel msg-skel-bubble" style="width: 200px;"></div>
                  </div>
                </div>
                <div class="message-wrapper-107 message-sender-107">
                  <div class="message-avatar-107"><div class="msg-skel msg-skel-avatar"></div></div>
                  <div class="message-content-wrapper-107">
                    <div class="msg-skel msg-skel-name"></div>
                    <div class="msg-skel msg-skel-bubble" style="width: 110px;"></div>
                  </div>
                </div>
                <div class="message-wrapper-107 message-receiver-107">
                  <div class="message-avatar-107"><div class="msg-skel msg-skel-avatar"></div></div>
                  <div class="message-content-wrapper-107">
                    <div class="msg-skel msg-skel-bubble" style="width: 170px;"></div>
                  </div>
                </div>
                <div class="message-wrapper-107 message-sender-107">
                  <div class="message-avatar-107"><div class="msg-skel msg-skel-avatar"></div></div>
                  <div class="message-content-wrapper-107">
                    <div class="msg-skel msg-skel-name"></div>
                    <div class="msg-skel msg-skel-bubble" style="width: 190px;"></div>
                  </div>
                </div>
              </div>

              <ng-container *ngIf="messageList?.length === 0 && !isMessagesLoading">
                <div class="chat-empty-state-107">
                  <img
                    src="assets\images\chatEmptyImage.svg"
                    alt="No messages"
                    class="chat-empty-state-image-107"
                  />

                  <div class="chat-empty-state-title-107">
                    No messages yet
                  </div>

                  <div class="chat-empty-state-subtitle-107">
                    Start a conversation with <span class="chat-empty-name-107"
                      title="{{ SelectedContact?.groupName }}">{{ SelectedContact?.groupName }}</span> — share a job,
                    ask about candidates, or just say hello.
                  </div>

                  <button
                    type="button"
                    class="chat-empty-state-button-107"
                    (click)="focusComposeBox()"
                    >
                    <ng-icon name="tablerSend"></ng-icon>
                    Send First Message
                  </button>

                </div>
              </ng-container>

              <!-- Messages List -->
              <ng-container *ngFor="let item of sortByMsg(messageList, 'sentDate') | messageunique">

                <!-- Regular Chat Message -->
                <div class="message-wrapper-107" *ngIf="item.eventType=='CHAT' || item.eventType==null"
                  [id]="item['messageId']"
                  [ngClass]="{'message-receiver-107': item['authorId'] === userId, 'message-sender-107': item['authorId'] !== userId}">

                  <!-- Avatar -->
                  <div class="message-avatar-107">
                    <img *ngIf="item['authorPhoto']" [src]="imgUrl + item['authorPhoto']" [alt]="item['authorName']"
                      onerror="this.src='assets/images/userAvatar.png'">
                    <div *ngIf="!item['authorPhoto']" class="circles-107-1"
                      [style.background-color]="getColorfullname(item['authorName'])">
                      <div class="circle-text-sm-107">{{ getInitialsfullname(item['authorName']) }}</div>
                    </div>
                  </div>

                  <!-- Message Content -->
                  <div class="message-content-wrapper-107">
                    <div class="message-sender-name-107" title="{{item['authorName']}}">{{item['authorName']}}</div>
                    <div class="message-bubble-107" *ngIf="!item.uploadPending"
                      [class.message-deleted-107]="item['deleted'] || item['message'] === 'This message was deleted'"
                      (click)="onBubbleImageClick($event)"
                      [innerHTML]="item['message']"></div>

                    <!-- Uploading pasted/dropped file: optimistic bubble + live percentage -->
                    <div class="msg-upload-pending-107" *ngIf="item.uploadPending">
                      <div class="msg-upload-items-107" [class.msg-upload-multi-107]="item.pendingItems?.length > 1">
                        <ng-container *ngFor="let p of item.pendingItems">
                          <div class="msg-upload-thumb-107" *ngIf="p.kind === 'image' && p.preview">
                            <img [src]="p.preview" alt="Sending photo">
                          </div>
                          <div class="msg-upload-file-107" *ngIf="p.kind !== 'image' || !p.preview">
                            <ng-icon *ngIf="p.kind === 'video'" name="tablerVideo"
                              class="msg-upload-file-icon-107"></ng-icon>
                            <ng-icon *ngIf="p.kind !== 'video'" name="tablerFile"
                              class="msg-upload-file-icon-107"></ng-icon>
                            <div class="msg-upload-file-name-107" [title]="p.name">{{ p.name }}</div>
                          </div>
                        </ng-container>
                      </div>
                      <div class="msg-upload-overlay-107">
                        <div class="msg-upload-pct-107">{{ item.uploadProgress || 0 }}%</div>
                        <div class="msg-upload-bar-107">
                          <div class="msg-upload-bar-fill-107" [style.width.%]="item.uploadProgress || 0"></div>
                        </div>
                      </div>
                    </div>

                    <!-- Media Attachments -->
                    <div class="message-media-107" [ngClass]="{'color-white-107': item['authorId'] !== userId}"
                      *ngIf="item.attachments && item.attachments.length > 0">
                      <ng-container *ngFor="let at of item.attachments; let a = index;">
                        <!-- Images -->
                        <div class="message-image-107" *ngIf="at['attachmentType'] === 'image'"
                          (click)="showImageAndVideoPreview(item, a)">
                          <img [src]="imgUrl + at['url']" [alt]="'Image attachment'">
                        </div>

                        <!-- Videos -->
                        <div class="message-video-107" *ngIf="at['attachmentType'] === 'video'"
                          (click)="showImageAndVideoPreview(item, a)">
                          <video controls>
                            <source [src]="imgUrl + at['url']" [type]="at['mimetype']">
                            Your browser doesn't support this video format
                          </video>
                        </div>

                        <!-- Other Attachments -->
                        <div class="message-attachment-107"
                          *ngIf="at['attachmentType'] === 'application' || at['attachmentType'] === 'others'">
                          <ng-icon name="tablerFile" class="attachment-icon-107"></ng-icon>
                          <div class="attachment-info-107">
                            <div class="attachment-name-107">{{at['name'] || 'Attachment'}}</div>
                            <div class="attachment-size-107">{{at['size'] ? (at['size'] ) : 'Unknown size'}}
                            </div>
                          </div>
                        </div>

                        <!-- Audio -->
                        <div class="message-attachment-107" *ngIf="at['attachmentType'] === 'audio'">
                          <audio controls>
                            <source [src]="imgUrl + at['url']" [type]="at['mimetype']">
                            Your browser doesn't support this audio format
                          </audio>
                        </div>
                      </ng-container>
                    </div>

                    <div class="message-time-107">
                      {{item['sentDate'] | timezoneDate:'custom'}}
                    </div>
                  </div>


                  <div class="btn-group three_icon_cmon1 hover" dropdown container="body">
                    <a id="button-animated" dropdownToggle *ngIf="item.enableDelete && item.authorId==userId">
                      <ng-icon name="tablerDots" class="three-dot"></ng-icon>
                    </a>
                    <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu msg-opts-menu" role="menu"
                      style="right: 0; left: auto;" aria-labelledby="button-animated">
                      <ng-container>
                        <li role="menuitem">
                          <a (click)="edit(item)">
                            <ng-icon name="tablerPencil" class="m-5"></ng-icon> Edit
                          </a>
                        </li>
                        <li role="menuitem">
                          <a (click)="delete(item)" class="msg-drop-danger">
                            <ng-icon name="tablerTrash" class="m-5"></ng-icon> Delete
                          </a>
                        </li>
                      </ng-container>
                    </ul>
                  </div>

                </div>

                <!-- System/Action Message -->
                <div class="system-message-wrapper-107" *ngIf="item.eventType=='ACTION'">
                  <div class="system-message-107" [innerHTML]="item['oldMessage']"></div>
                </div>
              </ng-container>
            </div>

            <!-- Chat Input -->
            <div class="chat-input-container-107"
              *ngIf="messageStatus === selectMessage.MESSAGE && SelectedContact.status!='INACTIVE'">
              <ng-container *ngIf="!attachment && !imageAttachmentEdit">
                <form class="chat-input-wrapper-107" #myForm="ngForm">
                  <div class="msg-input-tool" (click)="UploadFileInput.click()" title="Attach file">
                    <ng-icon name="tablerPaperclip"></ng-icon>
                    <input type="file" multiple id="attachmentfile" name="file"
                      accept="image/*,audio/*,video/*"
                      (click)="UploadFileInput.value=''"
                      (change)="fileUpload($event,'', 'fileupload')" #UploadFileInput style="display: none;" />
                  </div>

                  <div class="msg-emoji-wrap">
                    <div class="msg-input-tool msg-emoji-btn" (mousedown)="$event.preventDefault()"
                      (click)="toggleEmojiPicker()" title="Emoji">😊</div>
                    <div class="msg-emoji-pop" *ngIf="showEmojiPicker" (mousedown)="onPickerMousedown($event)">
                      <emoji-mart [isNative]="true" [showPreview]="false" [perLine]="8" [emojiSize]="20"
                        [emojisToShowFilter]="emojisToShowFilter"
                        title="Pick an emoji" emoji="point_up" [color]="'#8B5CF6'"
                        (emojiSelect)="insertEmoji($event.emoji.native)"></emoji-mart>
                    </div>
                  </div>

                  <div class="chat-input-col-107">
                    <!-- Editing hint — directly above the input, matching its width -->
                    <div class="edit-hint-107" *ngIf="editMessage">
                      <span class="edit-hint-label-107">
                        <ng-icon name="tablerPencil"></ng-icon> Editing message
                      </span>
                      <button type="button" class="edit-hint-cancel-107" (click)="cancelEdit()">Cancel</button>
                    </div>
                    <div id="mainComposeEditor" class="chat-input-107" [(ngModel)]="sendMessageData['message']" name="message"
                      [ngxSummernote]="config" summernoteValidator #message="ngModel" required>
                    </div>
                  </div>

                  <div class="chat-action-button-107 chat-send-button-107" *ngIf="!editMessage && !imageAttachmentEdit"
                    [class.disabled]="isButtonDisabled(message)" (click)="sendMessage()">
                    <ng-icon name="tablerSend"></ng-icon>
                  </div>

                  <div class="chat-action-button-107 chat-send-button-107" *ngIf="editMessage"
                    [class.disabled]="isButtonDisabled(message)" (click)="updateMsg()">
                    <ng-icon name="tablerCheck"></ng-icon>
                  </div>
                </form>
              </ng-container>
              <!-- Attachment Preview Section -->
              <div *ngIf="attachment && imageAttachmentEdit==false" class="attachment-preview-section-107">
                <!-- Attachment section content remains unchanged -->
                <div class="attachment-preview-list-107">
                  <div class="attachment-preview-item-107" *ngFor="let item of uploadFiles; let i = index;">
                    <!-- Image Attachment -->
                    <ng-container *ngIf="item['t'] === 'image'">
                      <div class="attachment-preview-image-107">
                        <img [src]="item['src']" alt="Image attachment">
                        <div class="attachment-preview-remove-107" (click)="removeAttachMent(item, i)">
                          <ng-icon name="tablerTrash"></ng-icon>
                        </div>
                      </div>
                    </ng-container>

                    <!-- Other attachment types... -->
                    <!-- Video Attachment -->
                    <ng-container *ngIf="item['t'] === 'video'">
                      <div class="attachment-preview-video-107">
                        <video controls (click)="toggleVideo()" #videoPlayer>
                          <source [src]="item['src']" [type]="item['ft']" />
                          Browser not supported
                        </video>
                        <div class="attachment-preview-remove-107" (click)="removeAttachMent(item, i)">
                          <ng-icon name="tablerTrash"></ng-icon>
                        </div>
                      </div>
                    </ng-container>

                    <!-- Other Attachment Types -->
                    <ng-container
                      *ngIf="item['t'] === 'audio' || item['t'] === 'application' || item['t'] === 'others'">
                      <div class="attachment-preview-file-107">
                        <ng-icon name="tablerFile" class="attachment-file-icon-107"></ng-icon>
                        <div class="attachment-file-name-107">{{item['name'] || 'File attachment'}}</div>
                        <div class="attachment-preview-remove-107" (click)="removeAttachMent(item, i)">
                          <ng-icon name="tablerTrash"></ng-icon>
                        </div>
                      </div>
                    </ng-container>
                  </div>

                  <!-- Add More Attachment Button -->
                  <div class="attachment-add-more-107">
                    <ng-icon name="tablerPlus"></ng-icon>
                    <input type="file" multiple accept="image/*,audio/*,video/*"
                      id="attachmentfile" name="file"
                      (click)="UploadFileInput.value=''"
                      (change)="fileUpload($event, UploadFileInput, 'update')"
                      #UploadFileInput />
                  </div>
                </div>

                <!-- Attachment Message Input -->
                <form class="chat-input-wrapper-107" (submit)="sendMessageWithAttachment()">
                  <div class="chat-input-107" [(ngModel)]="sendMessageData['message']" name="message"
                    [ngxSummernote]="config" summernoteValidator #message="ngModel" required>
                  </div>

                  <div class="chat-action-button-107 chat-send-button-107" [class.disabled]="isButtonDisabled(message)"
                    (click)="sendMessageWithAttachment()">
                    <ng-icon name="tablerSend"></ng-icon>
                  </div>
                </form>
              </div>

              <!-- Edit Attachment Section -->
              <div *ngIf="imageAttachmentEdit" class="attachment-preview-section-107">
                <div class="attachment-preview-list-107">
                  <div class="attachment-preview-item-107" *ngFor="let item of uploadFiles; let i = index;">
                    <!-- Image Attachment -->
                    <ng-container *ngIf="item['t'] === 'image'">
                      <div class="attachment-preview-image-107">
                        <img [src]="item['src']" *ngIf="item?.edit==undefined" alt="Image attachment">
                        <img [src]="imgUrl+item.url" *ngIf="item?.edit==true" alt="Image attachment">
                        <div class="attachment-preview-remove-107" (click)="removeAttachMentedit(item, i)">
                          <ng-icon name="tablerTrash"></ng-icon>
                        </div>
                      </div>
                    </ng-container>
              
                    <!-- Video Attachment -->
                    <ng-container *ngIf="item['t'] === 'video'">
                      <div class="attachment-preview-video-107">
                        <video controls (click)="toggleVideo()" #videoPlayer *ngIf="item?.edit==undefined">
                          <source [src]="item['src']" [type]="item['ft']" />
                          Browser not supported
                        </video>
                        <video controls (click)="toggleVideo()" #videoPlayer *ngIf="item?.edit==true">
                          <source [src]="imgUrl+item.url" [type]="item['ft']" />
                          Browser not supported
                        </video>
                        <div class="attachment-preview-remove-107" (click)="removeAttachMentedit(item, i)">
                          <ng-icon name="tablerTrash"></ng-icon>
                        </div>
                      </div>
                    </ng-container>
              
                    <!-- Other Attachment Types -->
                    <ng-container *ngIf="item['t'] === 'audio'">
                      <div class="attachment-preview-file-107">
                        <ng-icon name="tablerFile" class="attachment-file-icon-107"></ng-icon>
                        <div class="attachment-file-name-107">{{item['name'] || 'Audio attachment'}}</div>
                        <audio controls>
                          <source [src]="item?.edit ? imgUrl+item.url : item['src']" [type]="item['ft']">
                          Your browser does not support the audio tag.
                        </audio>
                        <div class="attachment-preview-remove-107" (click)="removeAttachMentedit(item, i)">
                          <ng-icon name="tablerTrash"></ng-icon>
                        </div>
                      </div>
                    </ng-container>
              
                    <ng-container *ngIf="item['t'] === 'application' || item['t'] === 'others'">
                      <div class="attachment-preview-file-107">
                        <ng-icon name="tablerFile" class="attachment-file-icon-107"></ng-icon>
                        <div class="attachment-file-name-107">{{item['name'] || 'File attachment'}}</div>
                        <div class="attachment-preview-remove-107" (click)="removeAttachMentedit(item, i)">
                          <ng-icon name="tablerTrash"></ng-icon>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                  
                  <!-- Add More Attachment Button -->
                  <div class="attachment-add-more-107">
                    <ng-icon name="tablerPlus"></ng-icon>
                    <input type="file" multiple accept="image/*,audio/*,video/*"
                      id="attachmentfile" name="file"
                      (click)="UploadFileInput.value=''"
                      (change)="fileUpload($event, UploadFileInput, 'update')"
                      #UploadFileInput />
                  </div>
                </div>
              
                <form class="chat-input-wrapper-107" (submit)="updatemediaApi()">
                  <div class="chat-input-107" [(ngModel)]="sendMessageData['message']" name="messagesss"
                    [ngxSummernote]="config" summernoteValidator #messagesss="ngModel" required>
                  </div>
                  
                  <div class="chat-action-button-107 chat-send-button-107" 
                       [class.disabled]="(uploadFiles.length === 0 && messagesss?.errors?.summernoteEmpty)"
                       (click)="updatemediaApi()">
                    <ng-icon name="tablerSend"></ng-icon>
                    Update
                  </div>
                </form>
              </div>
            </div>

            <!-- Inactive User Warning -->
            <div class="inactive-user-warning-107" *ngIf="SelectedContact?.status == 'INACTIVE'">
              <div class="warning-icon-107">
                <ng-icon name="tablerAlertCircle"></ng-icon>
              </div>
              <div class="warning-message-107">
                <ng-container *ngIf="SelectedContact?.groupType == 'USER'">
                  You are no longer connected with this user and cannot send messages.
                </ng-container>
                <ng-container *ngIf="SelectedContact?.groupType == 'JOB'">
                  You no longer have access to send message here.
                </ng-container>
                <ng-container *ngIf="SelectedContact?.groupType == 'CANDIDATE'">
                  You no longer have access to send message here.
                </ng-container>
                <ng-container *ngIf="SelectedContact?.groupType == 'TEAM'">
                  You no longer have access to send message here.
                </ng-container>
                <ng-container *ngIf="SelectedContact?.groupType == 'NETWORK'">
                  You no longer have access to send message here.
                </ng-container>
                <ng-container *ngIf="SelectedContact?.groupType == 'BUSINESS'">
                  You no longer have access to send message here.
                </ng-container>
                <ng-container *ngIf="SelectedContact?.groupType == 'GROUP'">
                  You no longer have access to send message here.
                </ng-container>
                <ng-container *ngIf="SelectedContact?.groupType == 'COMMUNITY'">
                  The community has been disabled for chat.
                </ng-container>
              </div>
            </div>
          </div>
        </div>


        <div class="col-md-3-500 widget-stand-900">
          <!-- Nothing selected yet: informative empty state (mirrors the middle chat panel)
               instead of a bare "No data to display". -->
          <div *ngIf="messageStatus === selectMessage.EMPTY" class="profile-empty-900">
            <div class="profile-empty-icon-900">
              <ng-icon name="tablerUsers"></ng-icon>
            </div>
            <div class="profile-empty-title-900">No conversation selected</div>
            <div class="profile-empty-subtitle-900">
              Pick a chat from the list to see contact details, shared jobs, and quick actions here.
            </div>
          </div>

          <app-message-details [MessageDetails]="contactList" [nodatafound]="nodatafound" [isLoading]="isLoading"
            [Jobandcandidatedetails]="Jobandcandidatedetails" [selectedMenu]="selectedMenu1"
            [SelectedContact]="SelectedContact" [GroupType]="SelectedContact?.groupType"
            (viewProfile)="routeProfie($event)"
            *ngIf="messageStatus !== selectMessage.EMPTY && (selectedMenu!='SUPPORT' && SelectedContact?.groupType!='SUPPORT')">
          </app-message-details>
          <app-common-widget *ngIf="messageStatus !== selectMessage.EMPTY && (selectedMenu=='SUPPORT'|| SelectedContact?.groupType=='SUPPORT')"
            [page]="'MESSAGE_PAGE'">
          </app-common-widget>
        </div>
      </div>
      <div class="fancybox">
        <div id="myModal" class="modall">
          <button class="close-button" (click)="closeFancyModal()">×</button>

          <div
            style="display: flex; position: fixed; left: 0px; right: 0px; top: 0px; bottom: 0px; justify-content: center; align-items: center; flex-direction: column; flex: 1 1 auto; align-self: stretch; overflow: hidden; z-index: 10000;">
            <div role="none"
              style="position: relative; display: flex; flex-direction: column; flex-grow: 1; flex-shrink: 1; overflow: visible; align-items: stretch; align-self: stretch;">
              <div role="none"
                style="position: relative; display: flex; flex-direction: column; flex-grow: 1; flex-shrink: 1; overflow: visible; align-items: center; align-self: stretch; justify-content: flex-start;">
                <div role="none"
                  style="position: absolute; display: flex; flex-direction: column; flex-grow: 0; flex-shrink: 0; overflow: hidden; align-items: center; left: 0px; right: 0px; top: 0px; bottom: 0px; background-color: rgb(0, 0, 0); justify-content: center; opacity: 1; transition: none 0s ease 0s;">
                </div>
                <div role="none"
                  style="position: absolute; display: flex; flex-direction: column; flex-grow: 0; flex-shrink: 0; overflow: visible; align-items: stretch; left: 0px; right: 0px; top: 0px; bottom: 0px; transform: translateX(0px);">
                  <div role="none" class="mySlidess" *ngFor="let item of fancyList"
                    style="position: absolute; display: flex; flex-direction: column; flex-grow: 0; flex-shrink: 0; overflow: visible; align-items: stretch; left: 0px; right: 0px; top: 0px; bottom: 0px; transform: translateX(0px);">
                    <div role="none"
                      style="position: absolute; display: flex; flex-direction: column; flex-grow: 0; flex-shrink: 0; overflow: visible; align-items: stretch; left: 0px; right: 0px; top: 0px; bottom: 0px; transform: translateY(0px);">
                      <div role="none"
                        style="position: relative; display: flex; flex-direction: column; flex-grow: 0; flex-shrink: 0; overflow: hidden; align-items: stretch; width: 100%; height: 100%;">
                        <div role="none"
                          style="position: relative; display: flex; flex-direction: column; flex-grow: 1; flex-shrink: 1; overflow: visible; align-items: stretch;">
                          <div
                            style="position: relative; display: flex; flex-direction: column; flex-grow: 1; flex-shrink: 1; overflow: visible; align-items: center; align-self: stretch; justify-content: center;">
                            <div
                              style="position: absolute; display: flex; flex-direction: column; flex-grow: 0; flex-shrink: 0; overflow: visible; align-items: stretch; justify-content: center; top: 0px; bottom: 0px; left: 0px; right: 0px; background-color: rgba(0, 0, 0, 0);">
                              <div role="none"
                                style="position: absolute; display: flex; flex-direction: column; flex-grow: 0; flex-shrink: 0; overflow: visible; align-items: stretch; left: 0px; right: 0px; top: 0px; bottom: 0px; width: 100%; height: 100%; opacity: 1; transform: translateX(0px);">
                                <div role="none"
                                  style="position: absolute; display: flex; flex-direction: column; flex-grow: 0; flex-shrink: 0; overflow: visible; align-items: stretch; left: 0px; right: 0px; top: 0px; bottom: 0px; transform: translateY(0px);">
                                  <div role="none"
                                    style="position: absolute; display: flex; flex-direction: column; flex-grow: 0; flex-shrink: 0; overflow: visible; align-items: stretch; left: 0px; right: 0px; top: 0px; bottom: 0px; transform: scale(1);">
                                    <div role="none"
                                      style="position: absolute; display: flex; flex-direction: column; flex-grow: 0; flex-shrink: 0; overflow: visible; align-items: stretch; left: 0px; right: 0px; top: 0px; bottom: 0px;">
                                      <ng-container *ngIf="item['attachmentType'] === 'image'">
                                        <div
                                          style="position: absolute; overflow: visible; background-color: transparent; flex-grow: 0; flex-shrink: 0; left: 0px; right: 0px; top: 0px; bottom: 0px; align-items: stretch; background-position: center center; background-repeat: no-repeat; background-size: contain; border-style: none; display: flex;"
                                          [style.background-image]="'url(' + (item['fullUrl'] || (imgUrl + item['url'])) + ')'">
                                        </div>
                                      </ng-container>
                                      <ng-container *ngIf="item['attachmentType'] === 'video'">
                                        <div
                                          style="position: absolute; overflow: visible; background-color: transparent; flex-grow: 0; flex-shrink: 0; left: 0px; right: 0px; top: 0px; bottom: 0px; align-items: stretch; background-position: center center; background-repeat: no-repeat; background-size: contain; border-style: none; display: flex;">
                                          <video controls (click)="toggleVideo()" #videoPlayer>
                                            <source [src]="imgUrl+item['url']" [type]="item['mimetype']" />
                                            Browser not supported
                                          </video>
                                        </div>
                                      </ng-container>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div role="none"
                  style="position: absolute; display: flex; flex-direction: column; flex-grow: 0; flex-shrink: 0; overflow: visible; align-items: stretch; left: -44px; top: 0px; bottom: 0px; justify-content: center; opacity: 1; transition: none 0s ease 0s;">
                  <button role="button" (click)="plusSlides(-1)" title="Previous" aria-label="Previous"
                    style="position: relative; display: flex; flex-direction: column; flex-grow: 0; flex-shrink: 0; overflow: hidden; align-items: center; justify-content: center; background-color: rgba(0, 0, 0, 0.65); border-color: transparent; text-align: left; border-width: 0px; padding-top: 35px; padding-bottom: 35px; left: 44px; padding-left: 14px; cursor: pointer; border-style: solid;">
                    <div aria-hidden="true" data-text-as-pseudo-element="" dir="auto"
                      style="position: relative; display: inline; flex-grow: 0; flex-shrink: 0; overflow: visible; white-space: pre-wrap; overflow-wrap: break-word; height: 44px; font-size: 44px; color: rgb(213, 217, 222); background-color: rgba(0, 0, 0, 0);  padding: 0px; flex-direction: row; align-self: center; align-items: center; justify-content: center; cursor: inherit;">
                      <ng-icon name="tablerChevronLeft"></ng-icon>
                    </div>
                  </button>
                </div>
                <div role="none"
                  style="position: absolute; display: flex; flex-direction: column; flex-grow: 0; flex-shrink: 0; overflow: visible; align-items: stretch; right: -44px; top: 0px; bottom: 0px; justify-content: center; opacity: 1; transition: none 0s ease 0s;">
                  <button role="button" (click)="plusSlides(1)" title="Next" aria-label="Next"
                    style="position: relative; display: flex; flex-direction: column; flex-grow: 0; flex-shrink: 0; overflow: hidden; align-items: center; justify-content: center; background-color: rgba(0, 0, 0, 0.65); border-color: transparent; text-align: left; border-width: 0px; padding-top: 35px; padding-bottom: 35px; right: 44px; padding-right: 14px; cursor: pointer; border-style: solid;">
                    <div aria-hidden="true" data-text-as-pseudo-element="" dir="auto"
                      style="position: relative; display: inline; flex-grow: 0; flex-shrink: 0; overflow: visible; white-space: pre-wrap; overflow-wrap: break-word; height: 44px; font-size: 44px; color: rgb(213, 217, 222); background-color: rgba(0, 0, 0, 0);  padding: 0px; flex-direction: row; align-self: center; align-items: center; justify-content: center; cursor: inherit;">
                      <ng-icon name="tablerChevronRight"></ng-icon>
                    </div>
                  </button>
                </div>
                <div role="none"
                  style="position: absolute; display: flex; flex-direction: row; flex-grow: 0; flex-shrink: 0; overflow: hidden; align-items: center; left: 0px; right: 0px; justify-content: flex-start; opacity: 1; transition: none 0s ease 0s;">
                  <div
                    style="position: absolute; overflow: visible; background-color: rgba(0, 0, 0, 0); flex-grow: 0; flex-shrink: 0; top: 0px; bottom: 0px; right: 0px; left: 0px; background-position: center center; background-repeat: no-repeat; background-size: 100% 100%; border-style: none; display: flex; margin-top: 60px;">
                  </div>
                  <div role="none"
                    style="justify-content: flex-end;position: relative; display: flex; flex-direction: row; flex-grow: 1; flex-shrink: 1; overflow: hidden; align-items: flex-start; align-self: stretch; margin-top: 60px !important;">
                    <button role="button" (click)="closeFancyModal()" title="Close" aria-label="Close picture."
                      style="position: relative; display: flex; flex-direction: column;  border-radius: 30px;  margin-top: 13px;flex-grow: 0; flex-shrink: 0; overflow: hidden; align-items: center; justify-content: center; background-color: #b72222; border-color: transparent; text-align: left; border-width: 0px; width: 48px; height: 48px; padding: 0px; cursor: pointer; border-style: solid;">
                      <div aria-hidden="true" data-text-as-pseudo-element="" dir="auto"
                        style="position: relative; display: inline; flex-grow: 0; flex-shrink: 0; overflow: visible; white-space: pre-wrap; overflow-wrap: break-word; height: 24px; font-size: 24px; color: rgb(255, 255, 255); background-color: rgba(0, 0, 0, 0);  padding: 0px; flex-direction: row; align-self: center; align-items: center; justify-content: center; cursor: inherit;">
                        <ng-icon name="tablerX"></ng-icon>
                      </div>
                    </button>
                  </div>
                </div>
                <div role="none"
                  style="position: absolute; display: flex; flex-direction: row; flex-grow: 0; flex-shrink: 0; overflow: hidden; align-items: center; left: 0px; right: 0px; justify-content: flex-start; bottom: 0px; opacity: 1; transition: none 0s ease 0s;">
                  <div
                    style="position: absolute; overflow: visible; background-color: rgba(0, 0, 0, 0); flex-grow: 0; flex-shrink: 0; top: 0px; bottom: 0px; right: 0px; left: 0px; transform: scaleY(-1); background-position: center center; background-repeat: no-repeat; background-size: 100% 100%; border-style: none; display: flex;">
                  </div>
                  <div role="none"
                    style="position: relative; display: flex; flex-direction: row; flex-grow: 1; flex-shrink: 1; overflow: hidden; align-items: stretch;">
                    <div role="none"
                      style="position: relative; display: flex; flex-direction: column; flex-grow: 1; flex-shrink: 1; overflow: hidden; align-items: stretch; height: 48px; padding-left: 10px; padding-right: 10px;">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #emptyscreen>
  <div class="chat-empty-container">
    <div class="chat-empty-content">
      <div class="chat-empty-icon">
        <ng-icon name="tablerMessages"></ng-icon>
      </div>
      <div class="chat-empty-title">Select a chat or start a new conversation</div>
      <div class="chat-empty-subtitle">
        Stay connected with your contacts through private and group chats
      </div>
      <div class="chat-empty-actions">
        <button class="btn primary-btn new-chat-btn" (click)="openNewContactModal(newContactModal)">
          <!-- <ng-icon name="tablerUserPlus"></ng-icon>  -->
          <ng-icon name="tablerUserPlus"></ng-icon>
          New Private Chat
        </button>
        <button class="btn primary-btn new-group-btn" (click)="openGroupContactModal(groupModal)">
          <!-- <ng-icon name="tablerUsers"></ng-icon>  -->
          <!-- <ng-icon name="tablerUsers"></ng-icon>    -->
          <img style="height: 26px; width: auto"  src="assets/icon/network.png" alt="">
          New Group Chat
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #groupModal>
  <div class="msg-panel" [class.closing]="panelClosing">
    <div class="msg-panel-hdr">
      <div class="msg-panel-title">New Group Chat</div>
      <button type="button" class="msg-panel-close" (click)="closePanelWithAnim()" aria-label="Close">
        <ng-icon name="tablerX"></ng-icon>
      </button>
    </div>

    <div class="msg-panel-body">
      <!-- Step indicator -->
      <div class="msg-step-indicator">
        <div class="msg-step-dot" [class.active]="groupStep === 1" [class.done]="groupStep > 1">1</div>
        <div class="msg-step-line" [class.done]="groupStep > 1"></div>
        <div class="msg-step-dot" [class.active]="groupStep === 2" [class.done]="groupStep > 2">2</div>
        <div class="msg-step-line" [class.done]="groupStep > 2"></div>
        <div class="msg-step-dot" [class.active]="groupStep === 3">3</div>
      </div>

      <!-- Step 1: Add members -->
      <div class="msg-step" *ngIf="groupStep === 1">
        <div class="msg-step-title">Add Members</div>
        <div class="msg-step-sub">Select people from your connections to add to this group.</div>

        <div class="msg-panel-search">
          <ng-icon name="tablerSearch" class="msg-panel-search-icon"></ng-icon>
          <input type="text" placeholder="Search connections..." name="groupname"
            (keyup)="handleKeyUp1($event)" [(ngModel)]="searchContent" (paste)="handlePaste1($event)">
        </div>

        <div class="msg-panel-list msg-pick-list" #scrollableDiv infiniteScroll [infiniteScrollDistance]="1"
          [infiniteScrollUpDistance]="2" [scrollWindow]="false" (scrolled)="onScrollcontacts()">
          <label class="msg-pick-row" *ngFor="let item of newContactList; let i=index;" [class.selected]="item.checked">
            <input type="checkbox" class="msg-pick-input" [(ngModel)]="item.checked" [name]="'pick_' + i"
              (change)="addUserToGroup($event, item['groupId'], item)">
            <span class="msg-pick-check"><ng-icon name="tablerCheck"></ng-icon></span>
            <div class="msg-connect-av">
              <img *ngIf="item['photo']" [src]="imgUrl+item['photo']">
              <div *ngIf="!item['photo']" class="msg-connect-av-fallback"
                [style.background-color]="getColorfullname(item['groupName'])"
                [style.color]="getFullNameTextColor(item['groupName'])">
                {{ getInitialsfullname(item['groupName']) }}
              </div>
            </div>
            <div class="msg-connect-info">
              <div class="msg-connect-name" title="{{item['groupName']}}">{{item['groupName']}}</div>
              <div class="msg-connect-role" title="{{ getConnectionSubtitle(item) }}">{{ getConnectionSubtitle(item) }}</div>
            </div>
          </label>

          <div *ngIf="stopScroll1 && newContactList.length === 0" class="msg-panel-end">
            <ng-icon name="tablerMailOff"></ng-icon>
            <p>No results found</p>
          </div>
        </div>

        <div class="msg-chips" *ngIf="groupData.name.length">
          <div class="msg-chip" *ngFor="let n of groupData.name; let ci=index;">
            {{ n }} <button type="button" (click)="removeGroupMemberChip(ci)" aria-label="Remove">&times;</button>
          </div>
        </div>
      </div>

      <!-- Step 2: Name the group -->
      <div class="msg-step" *ngIf="groupStep === 2">
        <div class="msg-step-title">Name Your Group</div>
        <div class="msg-step-sub">Give your group a name so members know what it's about.</div>
        <label class="msg-field-label">Group Name</label>
        <input type="text" class="msg-field-input" [(ngModel)]="groupData.groupName" trim="blur" name="groupName"
          placeholder="e.g. Java Recruiters Team">
      </div>

      <!-- Step 3: Confirm -->
      <div class="msg-step" *ngIf="groupStep === 3">
        <div class="msg-step-title">Review &amp; Create</div>
        <div class="msg-step-sub">Confirm the details before creating your group.</div>
        <div class="msg-review-row">
          <span>Group Name</span>
          <strong>{{ groupData.groupName || 'Auto-generated' }}</strong>
        </div>
        <div class="msg-review-row">
          <span>Members</span>
          <strong>{{ groupData.name.length }}</strong>
        </div>
        <div class="msg-chips" *ngIf="groupData.name.length">
          <div class="msg-chip" *ngFor="let n of groupData.name">{{ n }}</div>
        </div>
      </div>
    </div>

    <!-- Footer navigation -->
    <div class="msg-panel-ftr">
      <button type="button" class="msg-panel-btn-cancel" *ngIf="groupStep === 1" (click)="closePanelWithAnim()">Cancel</button>
      <button type="button" class="msg-panel-btn-cancel" *ngIf="groupStep > 1" (click)="prevGroupStep()">Back</button>
      <button type="button" class="msg-panel-btn-next" *ngIf="groupStep < 3"
        [disabled]="groupStep === 1 && (groupData.contacts.length || 0) < 2" (click)="nextGroupStep()">Next</button>
      <button type="button" class="msg-panel-btn-next" *ngIf="groupStep === 3" (click)="createGroup()">Create Group</button>
    </div>
  </div>
</ng-template>
<!--  Business memberList view -->

<ng-template #businessGrouplist>
  <div class="common-header-flex581">
    <div>Business Admins</div>
    <button class="common-close581" (click)="closeSliderNC()">
      <ng-icon name="tablerX"></ng-icon>
    </button>
  </div>

  <div class="modal-body581">
    <div class="message-search581">
      <div class="input-group581 f-l581">
        <input type="text" class="form-control pd-lt-30" name="groupname" id="" aria-describedby="helpId"
          placeholder="Search Admin" (keyup)="onSearchInputChange($event)" [(ngModel)]="searchContent"
          (paste)="handlePaste2($event)">
        <ng-icon name="tablerSearch" class="pos-rel-8"></ng-icon>
      </div>
    </div>

    <div class="userlist581 message-memberss581" #scrollableDiv infiniteScroll [infiniteScrollDistance]="1"
      [infiniteScrollUpDistance]="2" [scrollWindow]="false" (scrolled)="onscrollbusinessadminlist()">
      <div class="message-content581">
        <div class="userlist581">
          <div class="chat-user581" *ngFor="let item of groupBusinessListMembers;let i=index;">
            <div class="row581">
              <div class="col-md-9581">
                <img *ngIf="item['photo']" class="chat-avatar581" [src]="imgUrl+item['photo']">
                <div *ngIf="!item['photo']" class="business_Admin581"
                  [style.background-color]="getColortwo(item?.firstName, item?.lastName)">
                  <div class="BA-text581" [style.color]="getTextColor(item?.firstName, item?.lastName)">{{
                    getInitialstwo(item?.firstName,
                    item?.lastName) }}</div>
                </div>
                <div class="chat-user-name581">
                  <span class="status-dot581"
                    [style.background-color]=" item['online'] === 'ONLINE' ? 'var(--gs-green)' : 'var(--gs-gray-500)'"></span>
                  <a title=" {{item['firstName']}} {{item['lastName']}}"> {{item['firstName']}}
                    {{item['lastName']}}</a>
                  <div class="chat-title-name581" title="{{ getConnectionSubtitle(item) }}">{{ getConnectionSubtitle(item) }}</div>
                </div>
              </div>
              <div class="col-md-3581">
                <div class="custom-checkbox" title="Check users to include in conversation" style="top: -5px">
                  <div class="custom-checkbox" title="Check users to include in conversation" style="top: -5px">
                    <label class="checkbox-label font-normal">
                      <input type="checkbox" [(ngModel)]="item.checked"
                        [disabled]="item.disable||item.isSuperAdmin||SelectedContact.adminList[0]!=userId"
                        name="contacts" [value]="item['userId']"
                        (change)="addUserToBusiness($event, item['userId'],item)">
                      <span class="checkmark" style="top: -5px"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="display-grid581" *ngIf="!paginationFlag">
      <ng-icon name="tablerMailOff"></ng-icon>
      <p style="text-align: center;"> No data to display </p>
    </div>
  </div>

  <!-- Save — pinned footer -->
  <div class="group-btn581">
    <button type="submit" *ngIf="SelectedContact.adminList[0]==userId" class="btn btn-primary btn-block"
      (click)="changeBusiness('BUSINESS')">Save</button>
  </div>
</ng-template>

<!--  community memberList view -->

<ng-template #communityMemberview>


  <div class="hpanel">
    <div class="panel-heading" style="padding: 18px;">
      <div style="color: white;">Community Admins</div>
      <div class="panel-tools">
        <button type="button" class="close pull-right close-btn-btn" aria-label="Close"
          (click)="closeSliderNC()">
          <span aria-hidden="true"><ng-icon name="tablerX"></ng-icon></span>
        </button>
      </div>
    </div>
  </div>


  <div class="modal-body" style="padding: 10px !important;">
    <div class="message-search">
      <div class="input-group f-l">
        <input type="text" class="form-control" name="groupname" id="" aria-describedby="helpId"
          placeholder="Search Admin" (keyup)="onsearchMsgCommunity(searchBusgroupList)"
          [(ngModel)]="searchBusgroupList">
        <span class="input-group-addon" id="my_btn"><ng-icon name="tablerSearch"></ng-icon></span>
      </div>
    </div>

    <div class="message-content">
      <div class="userlist">
        <div class="chat-user"
          *ngFor="let item of groupCommunityListMembers | paginate: { itemsPerPage: 5, currentPage: page }">
          <div class="row">
            <div class="col-md-9">
              <img class="chat-avatar" [alt]="item['photo'] ? imgUrl+item['photo'] : 'assets/images/userAvatar.png'"
                [src]="item['photo'] ? imgUrl+item['photo'] : 'assets/images/userAvatar.png'"
                onerror="src='assets/images/userAvatar.png'">
              <div class="chat-user-name">
                <span class="status-dot"
                  [style.background-color]=" item['online'] === 'ONLINE' ? 'var(--gs-green)' : 'var(--gs-gray-500)'"></span>
                <a title="{{item['firstName']}} {{item['lastName']}}"> {{item['firstName']}}
                  {{item['lastName']}}</a>
              </div>
            </div>
            <div class="col-md-3">
              <div class="group-check-box">
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" [(ngModel)]="item.checked" [disabled]="item.disable"
                      name="contacts" [value]="item['userId']"
                      (change)="addUserTocommunity($event, item['userId'],item)">
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="group-name">
          <div class="form-group">
            <input type="text" class="form-control" [(ngModel)]="groupData.groupName" name="groupName" id=""
              aria-describedby="helpId" placeholder="Enter Group Name">
          </div>
        </div> -->

      <!-- <p *ngIf="!paginationFlag" style="text-align: center;"> No data to display </p> -->
      <div class="display-grid" *ngIf="!paginationFlag">
        <ng-icon name="tablerMailOff"></ng-icon>
        <p style="text-align: center;"> No data to display </p>
      </div>
      <pagination-controls *ngIf="paginationFlag" class="left-page-align" (click)="pagecount(page)"
        (pageChange)="page = $event">
      </pagination-controls>


      <div class="group-btn">
        <button type="submit" *ngIf="SelectedContact.adminList[0]==userId" class="btn btn-primary btn-block"
          (click)="changeBusiness('COMMUNITY')">save</button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Group Model for user Add -->

<ng-template #groupAdduserModal>
  <div class="common-header-flex100">
    <div class="modal-title100">Add User</div>
    <button class="close-button100">
      <span class="common-close100" (click)="closeAdduserModel()" aria-hidden="true"><ng-icon name="tablerX"></ng-icon></span>
    </button>
  </div>
  <div class="modal-body100" style="padding: 16px !important;">
    <div class="message-search100">
      <input type="text" class="form-control pd-lt-30" name="firstName" id="" aria-describedby="helpId"
        placeholder="Search New Contact" [(ngModel)]="searchContent"  (keyup)="handleKeyUp1($event)"
        (paste)="handlePaste1($event)">
      <ng-icon name="tablerSearch" class="pos-rel-25-100"></ng-icon>
    </div>
    <div class="userlist100 message-memberss100" #scrollableDiv infiniteScroll [infiniteScrollDistance]="1"
      [infiniteScrollUpDistance]="2" [scrollWindow]="false" (scrolled)="onScrollcontacts()">
      <div class="message-content100">
        <div class="userlist-container100">
          <div class="chat-user100" *ngFor="let item of newuserGroup;let i=index;">
            <div class="user-row100">
              <div class="user-info100">
                <span class="status-dot100"
                  [style.background-color]=" item['online'] === 'ONLINE' ? 'var(--gs-green)' : 'var(--gs-gray-500)'"></span>
                <img *ngIf="item['photo']" class="chat-avatar100" [src]="imgUrl+item['photo'] ">
                <div *ngIf="!item['photo']" class="business_Admin100"
                  [style.background-color]="getColortwo(item?.firstName, item?.lastName)">
                  <div class="BA-text100" [style.color]="getTextColor(item?.firstName, item?.lastName)">{{
                    getInitialstwo(item?.firstName,
                    item?.lastName) }}</div>
                </div>
                <div class="chat-user-name100">
                  <a title="{{item['firstName']}} {{item['lastName']}}">{{item['firstName']}}
                    {{item['lastName']}}</a>
                  <div class="chat-user-title100" title="{{ getConnectionSubtitle(item) }}">
                    {{ getConnectionSubtitle(item) }}
                  </div>
                </div>
              </div>
              <div class="checkbox-container100">
                <div class="group-check-box100">
                  <!-- <div class="form-check100">
                    <label class="form-check-label100">
                      <input type="checkbox" [(ngModel)]="item.checked" class="form-check-input100" value="{{item.userId}}"
                        (change)="onCheckboxChange(item,$event,newuserGroup)">
                      <span class="checkmark100"></span>
                    </label>
                  </div> -->
                  <div class="custom-checkbox" title="Check users to include in conversation">
                    <label class="checkbox-label font-normal">
                      <input type="checkbox" [(ngModel)]="item.checked" value="{{item.userId}}"
                        (change)="onCheckboxChange(item,$event,newuserGroup)">
                      <span class="checkmark" style="top: -5px"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="display-grid100" *ngIf="stopScroll1 && newuserGroup.length == 0">
      <ng-icon name="tablerMailOff"></ng-icon>
      <p class="no-data-text100"> No data to display </p>
    </div> 
    <div class="group-btn100">
      <div class="add-btn-cen100">
        <button type="submit" class="btn btn-primary btn-block" (click)="addUser()">Add User</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #userProfileNetworkTeam>

  <div class="common-header-flex493">
    <div class="group-title493" title="{{groupNameshow}}">{{groupNameshow}} </div>
    <button class="close-button493">
      <span (click)="closeSliderNC()" class="common-close493"><ng-icon name="tablerX"></ng-icon></span>
    </button>
  </div>

  <div class="modal-body493">
    <div class="message-search493" *ngIf="SelectedContact.createdBy!=userId">
      <div class="search-column493">
        <input type="text" class="form-control search-input012" name="firstName" id="" aria-describedby="helpId"
          placeholder="Search Contact Name" [(ngModel)]="searchContent" (keyup)="handleKeyUp($event)"
          (paste)="handlePaste($event)">
        <ng-icon name="tablerSearch" class="pos-re-30"></ng-icon>
      </div>
    </div>
    <div class="message-content493">
      <div class="userlist493 message-memberss493" #scrollableDiv infiniteScroll [infiniteScrollDistance]="1"
        [infiniteScrollUpDistance]="2" [scrollWindow]="false" (scrolled)="onScrollDownNetworkMembers()">

        <div class="chat-user493" *ngFor="let item of groupUserList; let i=index;">
          <div class="row493">
            <div class="col-md-10493">
              <img *ngIf="item['photo']" class="chat-avatar493" [src]="imgUrl+item['photo']">
              <div *ngIf="!item['photo']" class="business_Admin493"
                [style.background-color]="getColortwo(item?.firstName, item?.lastName)">
                <div class="BA-text493" [style.color]="getTextColor(item?.firstName, item?.lastName)">{{
                  getInitialstwo(item?.firstName,
                  item?.lastName) }}</div>
              </div>
              <div class="chat-user-name493">
                <span class="status-dot493"
                  [style.background-color]=" item['online'] === 'ONLINE' ? 'var(--gs-green)' : 'var(--gs-gray-500)'"></span>
                <a class="user-name-link493" title="{{item['firstName']}} {{item['lastName']}}">{{item['firstName']}}
                  {{item['lastName']}}
                  <span class="owner-tag493" *ngIf="item.userId == TempGroupUserList?.group?.createdBy"> (Owner) </span>
                </a>
                <div class="user-title493" title="{{ getConnectionSubtitle(item) }}">
                  {{ getConnectionSubtitle(item) }}
                </div>
              </div>
            </div>
            <div class="col-md-2493">
              <div class="group-check-box493"
                *ngIf="TempGroupUserList?.groupMembers?.length>1 && SelectedContact.createdBy==userId">
                <div class="form-check493" *ngIf="item.userId!=userId">
                  <img class="remove-icon493" src='assets/icon/delete_icon.png' (click)="removeGroupMember(item)">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="stopScroll1" class="end-of-list493">
          <div class="col-md-12493 mg-bt-9493">
            <ng-icon name="tablerCircleCheck"></ng-icon>
          </div>
          <div class="col-md-12493">
            <p class="biase493">You've reached the bottom of the page</p>
          </div>
        </div>
      </div>
      <div class="display-grid493 empty-state493" *ngIf="!paginationFlag">
        <ng-icon name="tablerMailOff"></ng-icon>
        <p class="no-data-text493"> No data to display </p>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #userProfiledata>
  <!-- Header Section -->
  <div class="common-header-flex776">
    <div class="text-ellipse776" title="{{groupNameshow}}">{{groupNameshow}}</div>
    <button class="close-button776">
      <span class="common-close776" (click)="closeSliderNC()" aria-hidden="true"><ng-icon name="tablerX"></ng-icon></span>
    </button>
  </div>

  <!-- Modal Body Section -->
  <div class="modal-body776">
    <div class="message-content776">
      <!-- Search Row — fixed on top (moved OUT of the scroll container) -->
      <div class="search-row776">
        <div class="search-column776"
          [ngClass]="{'col-10776': SelectedContact.createdBy==userId, 'col-12776': SelectedContact.createdBy!=userId}">
          <input type="text" class="form-control search-input012" name="firstName" aria-describedby="helpId"
            placeholder="Search Contact Name" [(ngModel)]="searchContent" (keyup)="handleKeyUp($event)"
            (paste)="handlePaste($event)">
          <ng-icon name="tablerSearch" class="pos-re-30"></ng-icon>
        </div>

        <!-- Add User Button (Only for Owner) -->
        <div class="add-button-column776" *ngIf="SelectedContact.createdBy==userId">
          <div title="Add members" class="add-user-button776"
            (click)="addcontact(groupAdduserModal,groupAdduserModal)">
            <ng-icon name="tablerUserPlus"></ng-icon>
          </div>
        </div>
      </div>

      <!-- Scrollable User List with Infinite Scroll -->
      <div class="userlist776 message-memberss776" #scrollableDiv infiniteScroll [infiniteScrollDistance]="1"
        [infiniteScrollUpDistance]="2" [scrollWindow]="false" (scrolled)="onScrollDownNetworkMembers()">

        <!-- User List -->
        <div class="chat-user776" *ngFor="let item of groupUserList;let i=index;">
          <div class="user-row776">
            <div class="user-info776">
              <!-- User Avatar -->
              <img *ngIf="item['photo']" class="chat-avatar776" [src]="imgUrl+item['photo']">
              <div *ngIf="!item['photo']" class="business_Admin776"
                [style.background-color]="getColortwo(item?.firstName, item?.lastName)">
                <div class="BA-text776" [style.color]="getTextColor(item?.firstName, item?.lastName)">
                  {{getInitialstwo(item?.firstName, item?.lastName)}}
                </div>
              </div>

              <!-- User Name and Status -->
              <div class="chat-user-name776">
                <!-- <div>{{item['online']}}</div>
                <div>{{item['offline']}}</div> -->
                <!-- <span *ngIf="item['offline'] === 'OFFLINE'" class="offline-dot776">
                </span>
                <span *ngIf="item['online'] === 'ONLINE'" class="online-dot776"></span> -->
                <span class="status-dot"
                  [style.background-color]=" item['online'] === 'ONLINE' ? 'var(--gs-green)' : 'var(--gs-gray-500)'"></span>
                <a title="{{item['firstName']}} {{item['lastName']}}">
                  {{item['firstName']}} {{item['lastName']}}
                  <span *ngIf="item.userId == TempGroupUserList?.group?.createdBy">(Owner)
                  </span>
                </a>
                <p class="owner-label776" title="{{ getConnectionSubtitle(item) }}">{{ getConnectionSubtitle(item) }}</p>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="action-buttons776">
              <div *ngIf="SelectedContact.createdBy==userId">
                <div class="form-check776" *ngIf="item.userId!=userId" (click)="removeGroupMember(item)">
                  <ng-icon name="tablerTrash"></ng-icon>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- Empty State -->
    <div class="empty-state776" *ngIf="stopScroll1 && groupUserList.length === 0">
      <ng-icon name="tablerMailOff"></ng-icon>
      <p>No data to display</p>
    </div>
  </div>

  <!-- Group Action Buttons — pinned footer at the bottom of the panel -->
  <div class="group-action-buttons776"
    *ngIf="SelectedContact.groupType!='TEAM' || SelectedContact.groupType!='NETWORK'">
    <button type="submit" class="btn primary-btn btn-block" *ngIf="SelectedContact.createdBy!=userId"
      (click)="exitGroup('user')">
      Leave Group
    </button>
    <button type="submit" class="btn primary-btn btn-block" *ngIf="SelectedContact.createdBy==userId"
      (click)="exitGroup('owner')">
      Delete Group
    </button>
  </div>
</ng-template>

<ng-template #newContactModal>
  <div class="msg-panel" [class.closing]="panelClosing">
    <div class="msg-panel-hdr">
      <div>
        <div class="msg-panel-title">New Private Chat</div>
        <div class="msg-panel-sub">Select a connection to start a conversation</div>
      </div>
      <button type="button" class="msg-panel-close" (click)="closePanelWithAnim()" aria-label="Close">
        <ng-icon name="tablerX"></ng-icon>
      </button>
    </div>

    <div class="msg-panel-body">
      <div class="msg-panel-search">
        <ng-icon name="tablerSearch" class="msg-panel-search-icon"></ng-icon>
        <input type="text" placeholder="Search connections by name or company..." (keyup)="handleKeyUp1($event)"
          [(ngModel)]="searchContent" (paste)="handlePaste1($event)">
      </div>

      <div class="msg-panel-section-label">Recent Connections</div>

      <div class="msg-panel-list scrollable-container-982" #scrollableDiv infiniteScroll
        [infiniteScrollDistance]="1" [infiniteScrollUpDistance]="2" [scrollWindow]="false"
        (scrolled)="onScrollcontacts()">
        <div class="msg-connect-row" *ngFor="let item of newContactList; let i=index;" (click)="singleRedirectUrl(item)">
          <div class="msg-connect-av">
            <img *ngIf="item['photo']" [src]="imgUrl+item['photo']">
            <div *ngIf="!item['photo']" class="msg-connect-av-fallback"
              [style.background-color]="getColorfullname(item['groupName'])"
              [style.color]="getFullNameTextColor(item['groupName'])">
              {{ getInitialsfullname(item['groupName']) }}
            </div>
            <span class="msg-connect-online"
              [style.background-color]="item['online'] === 'ONLINE' ? 'var(--gs-green)' : 'var(--gs-gray-500)'"></span>
          </div>
          <div class="msg-connect-info">
            <div class="msg-connect-name" title="{{item['groupName']}}">{{item['groupName']}}</div>
            <div class="msg-connect-role" title="{{ getConnectionSubtitle(item) }}">{{ getConnectionSubtitle(item) }}</div>
          </div>
          <span class="msg-connect-status" [class.online]="item['online'] === 'ONLINE'">
            <span class="msg-connect-dot"></span>{{ item['online'] === 'ONLINE' ? 'Online' : 'Offline' }}
          </span>
        </div>

        <div *ngIf="stopScroll1 && newContactList.length === 0" class="msg-panel-end">
          <ng-icon name="tablerMailOff"></ng-icon>
          <p>No results found</p>
        </div>
      </div>

      <div class="display-grid-982" *ngIf="!paginationFlag">
        <ng-icon name="tablerMailOff"></ng-icon>
        <p style="text-align: center;"> No data to display </p>
      </div>
    </div>

    <div class="msg-panel-ftr">
      <button type="button" class="msg-panel-btn-cancel" (click)="closePanelWithAnim()">Cancel</button>
    </div>
  </div>
</ng-template>

<ng-template #selecteduser>

  <div class="header-right chat-dis">
    <div>

      <div class="chat-avatar cursor append-item" *ngIf="(SelectedContact?.adminList !=null && SelectedContact?.adminList[0]==userId && SelectedContact?.groupType=='BUSINESS')
        ||(SelectedContact?.adminList !=null && SelectedContact?.adminList[0]==userId && SelectedContact?.groupType=='COMMUNITY')
        ||(SelectedContact?.createdBy==userId && SelectedContact?.groupType=='GROUP' && SelectedContact?.status=='ACTIVE')
        ||(SelectedContact?.createdBy==userId && SelectedContact?.groupType=='JOB' && SelectedContact?.status=='ACTIVE')
        ||(SelectedContact?.createdBy==userId && SelectedContact?.groupType=='CANDIDATE' && SelectedContact?.status=='ACTIVE')
        ||(SelectedContact?.createdBy==userId && SelectedContact?.groupType=='NETWORK')
        ||(SelectedContact?.createdBy==userId && SelectedContact?.groupType=='SUPPORT')
        ||(SelectedContact?.createdBy==userId && SelectedContact?.groupType=='TEAM')">
        <ng-icon name="tablerPlus" *ngIf="SelectedContact?.groupType!='CANDIDATE' && SelectedContact?.groupType!='JOB'"
          (click)="addcontact('',groupAdduserModal,businessGrouplist,communityMemberview)" aria-hidden="true"></ng-icon>

      </div>


      <img class="chat-avatar cursor" *ngIf="SelectedContact?.groupType === 'USER' && SelectedContact?.groupLogo"
        [src]="imgUrl + SelectedContact?.groupLogo" (click)="routeProfie(SelectedContact)">

      <div class="chat-avatar" *ngIf="!SelectedContact?.groupLogo && SelectedContact?.groupType === 'USER'">
        <div (click)="routeProfie(SelectedContact)"
          [style.background-color]="getColorfullname(SelectedContact?.groupName)">
          <div class="circletext">{{ getInitialsfullname(SelectedContact?.groupName) }}</div>
        </div>
      </div>



      <img class="chat-avatar cursor" *ngIf="SelectedContact.groupType=='SUPPORT'"
        onerror="src='assets/icon/Sumoface_final.png'" [src]="imgUrl+SelectedContact['groupLogo']"
        [alt]="imgUrl+SelectedContact['groupLogo']" (click)="routeProfie(SelectedContact)">


      <img class="chat-avatar cursor" *ngIf="SelectedContact.groupType=='TEAM'" (click)="routeProfie(SelectedContact)"
        onerror="src='assets/icon/icons8-people-100.png'" [src]="imgUrl+SelectedContact['groupLogo']"
        [alt]="imgUrl+SelectedContact['groupLogo']">

      <img class="chat-avatar cursor" *ngIf="SelectedContact.groupType=='NETWORK'"
        (click)="routeProfie(SelectedContact)"
        [src]="SelectedContact['groupLogo'] ? imgUrl+SelectedContact['groupLogo'] : 'assets/icon/icons8-share-400.png'">

      <img class="chat-avatar cursor" *ngIf="SelectedContact.groupType=='BUSINESS'"
        (click)="routeProfie(SelectedContact)" onerror="src='assets/images/gallery/company.png'"
        [src]="imgUrl+SelectedContact['groupLogo']" [alt]="imgUrl+SelectedContact['groupLogo']">

      <img class="chat-avatar cursor" *ngIf="SelectedContact.groupType=='COMMUNITY'"
        (click)="routeProfie(SelectedContact)" onerror="src='assets/icon/icons8-myspace-400.png'"
        [src]="imgUrl+SelectedContact['groupLogo']" [alt]="imgUrl+SelectedContact['groupLogo']">

      <img class="chat-avatar cursor" *ngIf="SelectedContact.groupType=='JOB'&&SelectedContact['groupLogo']"
        [src]="imgUrl+SelectedContact['groupLogo']">
      <div class="chat-avatar" *ngIf="!SelectedContact['groupLogo']&&SelectedContact.groupType=='JOB'">
        <div (click)="routeProfie(SelectedContact)" [style.background-color]="getColorfullname(SelectedContact?.title)">
          <div class="circletext" [style.color]="getFullNameTextColor(SelectedContact?.title)">{{
            getInitialsfullname(SelectedContact?.title) }}</div>
        </div>
      </div>
      <img class="chat-avatar cursor" *ngIf="SelectedContact.groupType=='CANDIDATE'&&SelectedContact['groupLogo']"
        [src]="imgUrl+SelectedContact['groupLogo']">
      <div class="chat-avatar" *ngIf="!SelectedContact['groupLogo']&&SelectedContact.groupType=='CANDIDATE'">
        <div (click)="routeProfie(SelectedContact)" [style.background-color]="getColorfullname(SelectedContact?.title)">
          <div class="circletext" [style.color]="getFullNameTextColor(SelectedContact?.title)">{{
            getInitialsfullname(SelectedContact?.title) }}</div>
        </div>
      </div>
      <img class="chat-avatar cursor"
        *ngIf="SelectedContact.groupType=='GROUP'&& SelectedContact.isAutoGeneratedGroupName!=true "
        onerror="src='assets/icon/groupimg.png'" [src]="imgUrl+SelectedContact['groupLogo']"
        (click)="userData(SelectedContact,userProfiledata,businessGrouplist,userProfileNetworkTeam)"
        [alt]="imgUrl+SelectedContact['groupLogo']">

      <ng-container *ngIf="SelectedContact.groupType=='GROUP' && SelectedContact.isAutoGeneratedGroupName==true">
        <ng-container *ngFor="let item of SelectedContact.members; let i = index;">
          <img class="chat-avatar cursor" *ngIf="i<=3" onerror="src='assets/images/userAvatar.png'"
            [src]="imgUrl+item.photo"
            (click)="userData(SelectedContact,userProfiledata,businessGrouplist,userProfileNetworkTeam)"
            [alt]="imgUrl+item.photo">
          <span style="font-weight:bold;" *ngIf="i==4">..</span>
        </ng-container>
      </ng-container>


      <!-- <div class="select_name cursor"  *ngIf="SelectedContact.isAutoGeneratedGroupName!=true && SelectedContact.groupType!='COMMUNITY'"
            (click)="userData(SelectedContact,userProfiledata,businessGrouplist,userProfileNetworkTeam)"> {{SelectedContact['groupName']}}
        </div>
         -->
      <div class="select_name cursor"
        *ngIf="SelectedContact.isAutoGeneratedGroupName!=true && SelectedContact.groupType=='COMMUNITY'"
        (click)="userData(SelectedContact,userProfiledata,communityMemberview,userProfileNetworkTeam)"
        title="{{SelectedContact['groupName']}}"> {{SelectedContact['groupName']}}
      </div>

      <div class="select_name cursor" *ngIf=" SelectedContact.groupType =='TEAM'"
        (click)="userData(SelectedContact,userProfileNetworkTeam,businessGrouplist,userProfileNetworkTeam)"
        title="{{SelectedContact['groupName']}}"> {{SelectedContact['groupName']}}
      </div>

      <div class="select_name cursor" *ngIf=" SelectedContact.groupType =='NETWORK'"
        (click)="userData(SelectedContact,userProfileNetworkTeam,businessGrouplist,userProfileNetworkTeam)"
        title="{{SelectedContact['groupName']}}"> {{SelectedContact['groupName']}}
      </div>

      <div class="select_name cursor" *ngIf=" SelectedContact.groupType =='GROUP'"
        (click)="userData(SelectedContact,userProfiledata,businessGrouplist,userProfileNetworkTeam)"
        title="{{SelectedContact['groupName']}}"> {{SelectedContact['groupName']}}
      </div>

      <div class="select_name cursor" *ngIf=" SelectedContact.groupType =='BUSINESS'"
        (click)="userData(SelectedContact,userProfiledata,businessGrouplist,userProfileNetworkTeam)"
        title="{{SelectedContact['groupName']}}"> {{SelectedContact['groupName']}}
      </div>

      <div class="select_name cursor" *ngIf=" SelectedContact.groupType =='USER'" (click)="routeProfie(SelectedContact)"
        title="{{SelectedContact['groupName']}}">
        {{SelectedContact['groupName']}}
      </div>

      <div class="select_name cursor" *ngIf=" SelectedContact.groupType =='JOB'"
        title="{{SelectedContact['groupName']}}">
        {{SelectedContact['groupName']}}
      </div>
      <div class="select_name cursor" *ngIf=" SelectedContact.groupType =='CANDIDATE'"
        title="{{SelectedContact['groupName']}}">
        {{SelectedContact['groupName']}}
      </div>

      <div class="select_name cursor" *ngIf=" SelectedContact.groupType =='SUPPORT'" title="Gigsumo Support">
        Gigsumo Support
      </div>

      <div class="cursor"
        *ngIf="SelectedContact.groupType=='BUSINESS' && SelectedContact.nonSeenCount!=0 &&   SelectedContact.newstatus=='ACTIVE'"
        (click)="userData(SelectedContact,userProfiledata,businessGrouplist,userProfileNetworkTeam)">
        Business Admin<span *ngIf="SelectedContact.nonSeenCount!=0">s</span> :{{SelectedContact.nonSeenCount}}
      </div>

      <div class="cursor"
        *ngIf="SelectedContact.groupType=='GROUP' && SelectedContact.nonSeenCount!=0 &&  SelectedContact.status=='ACTIVE'"
        (click)="userData(SelectedContact,userProfiledata,businessGrouplist,communityMemberview)">
        Group Member<span *ngIf="SelectedContact.nonSeenCount>1">s</span> :{{SelectedContact.nonSeenCount}}</div>

      <div class="cursor members_word" *ngIf="SelectedContact.groupType=='TEAM' && SelectedContact.nonSeenCount!=0 &&
          SelectedContact.status=='ACTIVE' &&   SelectedContact.members.length!=0"
        (click)="userData(SelectedContact,userProfileNetworkTeam,businessGrouplist,communityMemberview)">
        Member<span *ngIf="SelectedContact.members.length>1">s</span> :
        <ng-container>
          <span *ngFor="let item of SelectedContact.members; let i=index;">
            <span *ngIf="i<1"> {{item.firstName}} </span>
            <span *ngIf="i==1 && SelectedContact.members.length==1" (click)="listofUsers(userProfileNetworkTeam)">,
              1
              more.. </span>
            <span *ngIf="i==1 && SelectedContact.members.length>1" (click)="listofUsers(userProfileNetworkTeam)">,
              {{SelectedContact.members.length-1}} more.. </span>
          </span>
        </ng-container>
      </div>


      <div class="cursor members_word" *ngIf="SelectedContact?.groupType=='NETWORK' && SelectedContact?.nonSeenCount!=0 &&
           SelectedContact?.status=='ACTIVE' &&   SelectedContact?.members?.length!=0"
        (click)="userData(SelectedContact,userProfileNetworkTeam,businessGrouplist,communityMemberview)">
        Member<span *ngIf="SelectedContact?.members?.length>1">s</span> :
        <ng-container>
          <span *ngFor="let item of SelectedContact?.members; let i=index;">
            <span *ngIf="i<1"> {{item.firstName}} </span>
            <span *ngIf="i==1 && SelectedContact?.members?.length==1" (click)="listofUsers(userProfileNetworkTeam)">, 1
              more.. </span>
            <span *ngIf="i==1 && SelectedContact?.members?.length>1" (click)="listofUsers(userProfileNetworkTeam)">,
              {{SelectedContact.members.length-1}} more.. </span>
          </span>

        </ng-container>
      </div>



      <!-- <div class="cursor" *ngIf="SelectedContact.groupType=='NETWORK' && SelectedContact.nonSeenCount!=0 &&
           SelectedContact.status=='ACTIVE'"
            (click)="userData(SelectedContact,userProfileNetworkTeam,businessGrouplist,communityMemberview)">  Network Member
             <span *ngIf="SelectedContact.nonSeenCount>1">s</span> :{{SelectedContact.nonSeenCount}}</div> -->



      <div class="cursor"
        *ngIf="SelectedContact.groupType=='COMMUNITY' && SelectedContact.nonSeenCount!=0 &&  SelectedContact.newstatus=='ACTIVE'"
        (click)="userData(SelectedContact,userProfiledata,communityMemberview,communityMemberview)">
        Community Member<span *ngIf="SelectedContact.nonSeenCount>1">s</span> :{{SelectedContact.nonSeenCount}}
      </div>
    </div>
    <div class="third">
      <form class="navbar-form navbar-left app-form example-form">
        <input type="text" placeholder="Search..." [(ngModel)]="searchData.value" (input)="updateSearch($event)"
          debounceTime=1000 [matAutocomplete]="auto" autocomplete="off" name="searchData" class="form-control"
          #filterData>
        <!-- (keyup)="onSearchChange($event)"  -->
        <ng-container>
          <mat-autocomplete #auto="matAutocomplete" class="app-search-top">
            <ng-container *ngIf="searchData.value?.length>0">
              <mat-option *ngFor="let item of messageList | search: searchData.value" [value]="item['message']"
                (click)="getSearchMessageDetails(item)">

                <ng-container *ngIf="item.eventType=='CHAT' || item.eventType==null">
                  <span class="message-date">{{item['sentDate'] | timezoneDate}}</span>
                  <ng-container *ngIf="item.attachements">
                    <ng-container *ngFor="let img_item of item.attachments">
                      <img class="chat-avatar cursor" *ngIf="img_item.attachmentType=='image'"
                        [src]="imgUrl+img_item.url">
                      <video class="chat-avatar cursor" *ngIf="img_item.attachmentType=='video'" controls
                        (click)="toggleVideo()" #videoPlayer>
                        <source [src]="imgUrl+img_item.url" /> Browser not supported
                      </video>

                    </ng-container>
                  </ng-container>

                  <span [innerHtml]="item['message'] " class="message-txt"></span>
                </ng-container>
                <ng-container *ngIf="item.eventType=='ACTION'">
                  <span [innerHtml]="item['oldMessage']" style="text-align: center;font-size: 10px; color: #655b4e;"
                    class="message-txt"></span>
                </ng-container>

              </mat-option>

            </ng-container>

          </mat-autocomplete>
        </ng-container>
      </form>
    </div>
    <!-- <div class="third">
        <button type="button" class="btn btn-primary">New Message</button>
        <ng-container *ngIf="emptyMsgOpt.opt === 'empty'; then emptyscreen; else emptyscreen">
        </ng-container>
      </div> -->
    <div class="forth" style="margin-top: 5px; margin-right: -7px;">
      <!-- <button class="btn-xs" mat-mini-fab color="warn" (click)="closeOpenedMsg()">
          <mat-icon>close</mat-icon>
        </button> -->
      <button class="close-btn" type="button" (click)="closeOpenedMsg()">
        <ng-icon name="tablerX"></ng-icon>
      </button>

      <!-- <button type="button" class="btn btn-danger btn-close-btn btn-xs" (click)="closeOpenedMsg()">
          <ng-icon name="tablerX"></ng-icon>
        </button> -->
    </div>
  </div>
</ng-template>